
import { Box } from '@chakra-ui/react';

import React, { useContext, useEffect, useState,useMemo,useRef,useCallback } from 'react';
import WalkAudio from "../../../../assets/adiuo/Walk_Audio_new.mp3";
import DoorParticles from "./DoorParticles";
import QuestProgressBar from "./QuestProgressBar";
import QuestHubLab from './ThreeQuestHubScene';

import FutureMale from "../../../../assets/Dialogueimgs/FutureMale.png";
import Futurefemale from "../../../../assets/Dialogueimgs/Futurefemale.png";
import { ScoreContext } from '../GamePreview';
import { ProfileContext } from '../EntirePreview';

import {cognizantoverviewgetmetho} from 'utils/game/gameService';
import { Buttons } from "../../../../components/ui/button";

import { ChevronLeft, ChevronRight } from "lucide-react";
import { useColor } from "../../../../components/ui/ColorContext";
import { API_SERVER } from 'config/constant';
import Door1 from '../../../../../src/assets/img/screens/Door1.mp4'
import Door2 from '../../../../../src/assets/img/screens/Door2.mp4'
import Door3 from '../../../../../src/assets/img/screens/Door3.mp4'
import Door4 from '../../../../../src/assets/img/screens/Door4.mp4'
import Quest1_Arms from '../../../../../src/assets/img/screens/Quest1_Arms.mp4'
import Quest2_Limbs from '../../../../../src/assets/img/screens/Quest2_Limbs.mp4'
import Quest3_Brain from '../../../../../src/assets/img/screens/Q3_Brain.mp4'
import Quest4_Heart from '../../../../../src/assets/img/screens/Q4_Heart.mp4'
import {
  activityCreate,
  activitygetlastblock,
  getGameActId,
} from 'utils/gameApplication/gameActivityService';
import { useParams } from 'react-router-dom';
import MalePlayer2 from "../../../../assets/Dialogueimgs/MalePlayer2.png";
import FemalePlayer2 from "../../../../assets/Dialogueimgs/FemalePlayer2.png";

import MalePlayer3 from "../../../../assets/Dialogueimgs/MalePlayer3.png";
import FemalePlayer3 from "../../../../assets/Dialogueimgs/FemalePlayer3.png";



import FemaleMentor from "../../../../assets/Dialogueimgs/FemaleMentor.png";
import MaleMentor from "../../../../assets/Dialogueimgs/MaleMentor.png";
import { updateScreenActivity } from '../common';

declare global {
  interface Window {
    _videoBlobCache?: Map<string, string>;
  }
}

const starAnimations = `
@keyframes starFill {
  0% {
    transform: scale(0.6);
    opacity: 0;
    fill: transparent;
    filter: drop-shadow(0 0 0px var(--primary-color));
  }

  40% {
    transform: scale(1.3);
    opacity: 1;
    fill: var(--primary-color);
    filter: drop-shadow(0 0 12px var(--primary-color));
  }

  70% {
    transform: scale(0.9);
  }

  100% {
    transform: scale(1);
    fill: var(--primary-color);
    filter: drop-shadow(0 0 8px var(--primary-color));
  }
}`;





// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = starAnimations;
  document.head.appendChild(styleSheet);
}



const milestoneContent: Record<string, { title: string; description: string }> = {
  '1': {
    title: 'Milestone Unlocked',
    description:
      "You’ve completed the first step. Your decisions have activated ECHO’s Arms module. ECHO can now interact with its environment.",
  },
  '2': {
    title: 'Milestone Unlocked',
    description:
           "You’re building momentum. Your choices have activated ECHO’s Mobility module. ECHO can now move with stability and control.",
  },
  '3': {
    title: 'Milestone Unlocked',
    description:
      "You’ve moved into advanced decision-making. Your choices have activated ECHO’s Cognitive module. ECHO can now recognise patterns and trade-offs.",
  },
  '4': {
    title: 'Milestone Unlocked',
    description:
      "You’ve demonstrated thoughtful leadership. Your decisions have activated ECHO’s Values module. ECHO can now build trust through its actions.",
  },
};

const CertificateButton = ({ onClick,isDialogOpen }: { onClick: () => void; isDialogOpen: boolean; }) => {
  const { primaryColor } = useColor();
  const [isHovered, setIsHovered] = useState(false);
  const [phase, setPhase] = useState<'flying' | 'bouncing' | 'revealed'>('flying');

  useEffect(() => {
    // ball flies in first
    const t1 = setTimeout(() => setPhase('bouncing'), 700);
    // then bounces on the floor a few times
    const t2 = setTimeout(() => setPhase('revealed'), 700 + 1400);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  return (
    <>
      <style>{`
        /* Ball flies in from off-screen right */
        @keyframes ball-fly-in {
          0% {
            transform: translate(220px, -120px) scale(0.6);
            opacity: 0;
          }
          40% { opacity: 1; }
          100% {
            transform: translate(0, 0) scale(1);
            opacity: 1;
          }
        }

        /* Ball bounces on the floor, losing height each time */
        @keyframes ball-bounce {
          0%   { transform: translateY(0) scaleX(1) scaleY(1); }
          10%  { transform: translateY(0) scaleX(1.25) scaleY(0.75); } /* squash on impact */
          30%  { transform: translateY(-70px) scaleX(0.9) scaleY(1.1); }
          45%  { transform: translateY(0) scaleX(1.2) scaleY(0.8); }
          55%  { transform: translateY(0) scaleX(1.2) scaleY(0.8); }
          70%  { transform: translateY(-32px) scaleX(0.95) scaleY(1.05); }
          80%  { transform: translateY(0) scaleX(1.15) scaleY(0.85); }
          88%  { transform: translateY(-12px) scaleX(0.97) scaleY(1.03); }
          94%  { transform: translateY(0) scaleX(1.08) scaleY(0.92); }
          100% { transform: translateY(0) scaleX(1) scaleY(1); }
        }

        /* Ball "opens" into the pill button */
        @keyframes ball-to-button {
          0%   { width: 56px; border-radius: 9999px; }
          100% { width: var(--btn-width, 180px); border-radius: 9999px; }
        }

        @keyframes cert-pulse-ring {
          0% { transform: scale(1); opacity: 0.6; }
          70% { transform: scale(1.6); opacity: 0; }
          100% { transform: scale(1.6); opacity: 0; }
        }
        @keyframes cert-float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-6px); }
        }
        @keyframes cert-shine {
          0% { transform: translateX(-150%) skewX(-20deg); }
          100% { transform: translateX(250%) skewX(-20deg); }
        }
        @keyframes text-fade-in {
          0% { opacity: 0; transform: translateX(-6px); }
          100% { opacity: 1; transform: translateX(0); }
        }
      `}</style>

      <div
        className="fixed bottom-6 right-6 z-50"
        style={{
           bottom: isDialogOpen ? "190px" : "24px",
            transition: "bottom 0.3s ease",
          animation:
            phase === 'flying'
              ? 'ball-fly-in 0.7s cubic-bezier(0.3, 0.6, 0.7, 1) forwards'
              : phase === 'revealed'
              ? 'cert-float 3s ease-in-out infinite'
              : undefined,
        }}
      >
        {/* Pulsing ring — only once revealed */}
        {phase === 'revealed' && (
          <span
            className="absolute inset-0 rounded-full"
            style={{
              background: primaryColor,
              animation: 'cert-pulse-ring 2s ease-out infinite',
            }}
          />
        )}

        {/* Trophy badge — only once revealed */}
        {phase === 'revealed' && (
          <span
            className="absolute -top-2 -right-2 z-10 flex h-6 w-6 items-center justify-center rounded-full text-[10px] font-bold text-black shadow-md"
            style={{ background: '#FFD700' }}
          >
            🏆
          </span>
        )}

        <button
          onClick={phase === 'revealed' ? onClick : undefined}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className="relative flex items-center justify-center overflow-hidden text-sm font-bold text-white backdrop-blur-md transition-[width,transform] duration-300"
          style={{
            height: '52px',
            width: phase === 'revealed' ? '180px' : '52px',
            borderRadius: '9999px',
            background: `linear-gradient(135deg, ${primaryColor}, rgba(0,0,0,0.75))`,
            border: `1.5px solid ${primaryColor}`,
            boxShadow:
              phase === 'revealed' && isHovered
                ? `0 0 25px ${primaryColor}, 0 0 45px ${primaryColor}`
                : `0 0 15px ${primaryColor}`,
            transform: phase === 'revealed' && isHovered ? 'scale(1.06)' : 'scale(1)',
            animation:
              phase === 'bouncing'
                ? 'ball-bounce 1.4s cubic-bezier(0.3, 0, 0.6, 1) forwards'
                : undefined,
            transformOrigin: 'bottom center',
          }}
        >
          {/* Shine sweep — only once revealed */}
          {phase === 'revealed' && (
            <span
              className="pointer-events-none absolute inset-0"
              style={{
                background:
                  'linear-gradient(120deg, transparent, rgba(255,255,255,0.5), transparent)',
                width: '40%',
                animation: 'cert-shine 3s ease-in-out infinite',
                animationDelay: '1s',
              }}
            />
          )}

          {/* While flying/bouncing, show just the icon (the "ball"). Once revealed, show icon + text */}
          <span className="relative z-10 flex items-center gap-2 whitespace-nowrap px-2">
            🎓
            {phase === 'revealed' && (
              <span style={{ animation: 'text-fade-in 0.4s ease-out forwards' }}>
                Certification
              </span>
            )}
          </span>
        </button>
      </div>
    </>
  );
};

const NormalCertificateButton = ({ onClick }: { onClick: () => void }) => {
  const { primaryColor } = useColor();

  return (
    <button
      onClick={onClick}
      className="fixed bottom-6 right-6 z-50 rounded-full px-5 py-2 text-sm font-semibold text-white backdrop-blur-md"
      style={{
        background: 'rgba(0,0,0,0.55)',
        border: `1px solid ${primaryColor}`,
        boxShadow: `0 0 12px ${primaryColor}`,
        marginBottom: '1rem',
        marginRight: '4rem'
      }}
    >
      🎓 Certification
    </button>
  );
};
let audioCtx: AudioContext | null = null;

function getAudioContext() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
  }
  if (audioCtx.state === 'suspended') {
    audioCtx.resume();
  }
  return audioCtx;
}

function playMilestoneSound() {
  const ctx = getAudioContext();
  const now = ctx.currentTime;

  const notes = [523.25, 659.25, 783.99, 1046.5, 1318.5];

  notes.forEach((freq, i) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();

    osc.type = i % 2 === 0 ? 'sine' : 'triangle';
    osc.frequency.value = freq;

    const startTime = now + i * 0.08;

    gain.gain.setValueAtTime(0, startTime);
    gain.gain.linearRampToValueAtTime(0.12, startTime + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.02, startTime + 0.4);
    gain.gain.exponentialRampToValueAtTime(0.001, startTime + 0.8);

    osc.connect(gain);
    gain.connect(ctx.destination);

    osc.start(startTime);
    osc.stop(startTime + 0.8);
  });
}
const MilestoneOverlay = ({
  questId,
  onContinue,
}: {
  questId: string;
  onContinue: () => void;
}) => {
  
  const content = milestoneContent[questId];
  useEffect(() => {
  playMilestoneSound();
}, [questId]);
  if (!content) return null;


  return (
    <div className="milestone-overlay active">
      <div className="milestone-card">

        <div className="milestone-scanlines" />

        <div className="milestone-icon">
          <svg viewBox="0 0 64 64">
            <circle cx="32" cy="32" r="28" strokeDasharray="4 4" />
            <path d="M32 12 L32 24 M32 40 L32 52 M12 32 L24 32 M40 32 L52 32" />
            <circle cx="32" cy="32" r="8" />
            <polygon points="32,20 35,28 32,26 29,28" fill="var(--cyan)" />
            <polygon points="32,44 35,36 32,38 29,36" fill="var(--cyan)" />
          </svg>
        </div>

        <h2 className="milestone-title">{content.title}</h2>
        <p className="milestone-description">{content.description}</p>

        <button className="milestone-btn" onClick={onContinue}>
          Continue
        </button>

      </div>
    </div>
  );
};

const NavigationArrow: React.FC<{
    direction: "left" | "right";
    onClick: () => void;
  }> = ({ direction, onClick }) => {
    const { primaryColor } = useColor();
    return (
      <Buttons
        variant="ghost"
        size="sm"
        onClick={onClick}
        className="w-[3.75rem] h-10 py-2 px-4 rounded-3xl transition-all duration-200 hover:scale-110"
        style={{
          background: `linear-gradient(${
            direction === "left" ? "275.041deg" : "90deg"
          },
                rgba(${hexToRgb(primaryColor)}, 0.6) 7.25%, rgba(${hexToRgb(
            primaryColor
          )}, 0.15) 84.803%)`,
          border: `1px solid ${primaryColor}`,
          boxShadow: `0px 0px 15.9542px 0px rgba(${hexToRgb(
            primaryColor
          )}, 0.3)`,
        }}
      >
        {direction === "left" ? (
          <ChevronLeft className="!w-4 !h-4 text-white" />
        ) : (
          <ChevronRight className="!w-4 !h-4 text-white" />
        )}
      </Buttons>
    );
  };

const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return "0, 255, 187"; // fallback to default green
  const r = Number.parseInt(result[1], 16);
  const g = Number.parseInt(result[2], 16);
  const b = Number.parseInt(result[3], 16);
  return `${r}, ${g}, ${b}`;
};


const normalizeStarValue = (value: number): number => {
  const clamped = Math.max(0, Math.min(1, Number(value) || 0));
  if (clamped >= 0.999) return 1;
  if (clamped <= 0.001) return 0;
  return clamped;
};

const calculateStarFill = (
  currentPoints: number,
  totalPoints: number,
): number[] => {
  if (totalPoints <= 0) return [0, 0, 0];

  const pointsPerStar = totalPoints / 3;

  return [0, 1, 2].map((index) =>
    normalizeStarValue(
      Math.max(currentPoints - index * pointsPerStar, 0) / pointsPerStar,
    ),
  );
};

const QuestStars: React.FC<{
  currentPoints: number;
  totalPoints: number;
  // primaryColor: string;
  gradientIdPrefix: string;
  // }> = ({ currentPoints, totalPoints, primaryColor, gradientIdPrefix }) => {
}> = ({ currentPoints, totalPoints, gradientIdPrefix }) => {
  const filledStars = calculateStarFill(currentPoints, totalPoints);
  const starFillColor = '#00f2ff';

  return (
    <Box display="flex" gap="8px" justifyContent="center" mb="4px">
      {filledStars.map((fill, index) => {
        const star = index + 1;
        const gradientId = `${gradientIdPrefix}-plasmaGrad-${star}`;
        const maskGradientId = `${gradientIdPrefix}-fillMask-${star}`;
        const maskId = `${gradientIdPrefix}-starMask-${star}`;
        const isLit = fill > 0;

        return (
          <Box key={star} position="relative" w="14px" h="14px">
            <svg
              width="14px"
              height="14px"
              viewBox="0 0 24 24"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                filter: isLit
                  ? `drop-shadow(0 0 10px ${starFillColor}) drop-shadow(0 0 2px #fff)`
                  : 'drop-shadow(0 0 2px rgba(0,242,255,0.3))',
                animation: isLit
                  ? `starFill 0.6s ease forwards ${star * 0.4}s`
                  : 'emptyStarShimmer 3s ease-in-out infinite',
              }}
            >
              <defs>
                <radialGradient id={gradientId} cx="50%" cy="50%" r="50%">
                  <stop offset="0%" stopColor="#ffffff" />
                  <stop offset="40%" stopColor={starFillColor} />
                  <stop offset="100%" stopColor={starFillColor} stopOpacity="0.3" />
                </radialGradient>
                <linearGradient
                  id={maskGradientId}
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="0%"
                >
                  <stop offset={`${fill * 100}%`} stopColor="white" />
                  <stop offset={`${fill * 100}%`} stopColor="black" />
                </linearGradient>
                <mask id={maskId}>
                  <rect width="24" height="24" fill={`url(#${maskGradientId})`} />
                </mask>
              </defs>
              <polygon
                points="12,2 15,9 22,9 17,14 19,21 12,17 5,21 7,14 2,9 9,9"
                fill={isLit ? `url(#${gradientId})` : 'transparent'}
                mask={fill === 1 ? undefined : `url(#${maskId})`}
                stroke={isLit ? '#00f2ff' : 'rgba(0, 242, 255, 0.5)'}
                strokeWidth="1"
              />
              <circle
                cx="12"
                cy="12"
                r="2"
                fill={
                  isLit
                    ? 'rgba(255, 255, 255, 0.95)'
                    : `rgba(0.2)`
                  // : `rgba(${hexToRgb(primaryColor)}, 0.2)`
                }
              />
            </svg>
          </Box>
        );
      })}
    </Box>
  );
};
  const EnumType = {
    BGM: 'bgm',
    VOICE: 'voice',
  };
const ChapterPage: React.FC<{
  gameProgressData?:any;
  setGameProgressData?:any;
   fetchchapterQuestScore:() => void;
  setIsDoorEntry?: (value: boolean) => void;
  toggleAudioPlayPause?:any;
  isSettingOpen:any;
            setIsSettingOpen:any;
  questWiseMaxScore: any;
  questTotalScore: any;
  overallqueststate: any;
  completedVideoRef: any;
  questState: any;
  setQuestState: any;
  backgroundImg: any;
  setCurrentScreenId: any;
  setCurrentQuestNo?: any;
   currentQuestNo?: number;
  setData?: any;
  setType?: any;
  setOptions?: any;
  setFeedbackList?: any;
  preloadedAssets?: any;
  SetGlbPlayingDetails?: any;
  glbName?: any;
  GlbPlayindDetails?: any;
  currentScreenId: any;
  profileData: any;
  gameInfo: any;
  setModalLoaded?: any;
  modalLoaded?: any;
  setLearnerPlayingDetails: any;
  learnerPlayList: any;
  setAssignId: any;
  AssignId: any;
  Activitydata: any;
  setActivitydata: any;
  setprevBlock: any;
  prevBlock: any;
  setNavi: any;
  getData: any;
  setFeed: any;
  setRepeatSelectOption: any;
  RepeatPrevOption: any;
  setRepeatPrevOption: any;
  setReplayState: any;
  setReplayIsOpen: any;
  setIsZoomComplete: any;
  isZoomComplete: any;
  handleReplayButtonClick: any;
  scoreChapter: any;
  setScoreChapter: any;
  questWisePlayerScore: any;
  setQuestWisePlayerScore: any;
  checkCompletionBadge: any;
  NonPlayerNameLanguage: any;
  NonPlayerNameLanguageId: any;
   setHubDialogAudio:any;
hubDialogAudio:any;
 audioObj:any;
                       setAudioObj:any;

  PlayerNameLanguage: any;
    isAnimationPaused?: boolean;
    mentorNameLanguage:any;
      reportFetchData:any;
       isAudioPaused?:any;
       setGameInfo?:any
}> = ({
  setGameProgressData,
    gameProgressData,
  fetchchapterQuestScore,
setGameInfo,
    setIsDoorEntry,
    toggleAudioPlayPause,
    isAudioPaused,
  isSettingOpen,
  setIsSettingOpen,
  questWiseMaxScore,
  questTotalScore,
  overallqueststate,
  completedVideoRef,
  handleReplayButtonClick,
  setCurrentScreenId,
  setCurrentQuestNo,
  questState,
  setQuestState,
  setData,
  setType,
  setOptions,
  setFeedbackList,
  preloadedAssets,
  glbName,
  GlbPlayindDetails,
  SetGlbPlayingDetails,
  currentScreenId,
  profileData,
  gameInfo,
  backgroundImg,
    currentQuestNo,
  modalLoaded,
  setModalLoaded,
  setLearnerPlayingDetails,
  learnerPlayList,
  AssignId,
  setAssignId,
  Activitydata,
  setActivitydata,
  prevBlock,
  setprevBlock,
  setNavi,
  getData,
  setFeed,
  setRepeatSelectOption,
  RepeatPrevOption,
  setRepeatPrevOption,
  setReplayIsOpen,
  setReplayState,
  setIsZoomComplete,
  isZoomComplete,
  scoreChapter,
  setScoreChapter,
  setQuestWisePlayerScore,
  questWisePlayerScore,
  checkCompletionBadge,
  NonPlayerNameLanguage,
  NonPlayerNameLanguageId,
  PlayerNameLanguage,
  hubDialogAudio,
  setHubDialogAudio,
   audioObj,
 setAudioObj,
 mentorNameLanguage,
  isAnimationPaused = false,
    reportFetchData,

}) => {
  const { primaryColor } = useColor();
 const [fx, setFx] = useState(false);
  const [fxPos, setFxPos] = useState({ x: 0, y: 0 });

  const handleDoorClick = (
    e: React.MouseEvent,
    doorId: string
  ) => {
    const rect = (
      e.currentTarget as HTMLElement
    ).getBoundingClientRect();

    setFxPos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });

    setFx((p) => !p); // toggle to retrigger

    handleQuestClickWithValidation(doorId);
  };

  // ===== AUDIO ENGINE =====
let audioCtx: AudioContext | null = null;

const getAudioContext = (): AudioContext => {
  if (!audioCtx) {
    audioCtx = new AudioContext(); // modern browsers
  }

  if (audioCtx.state === 'suspended') {
    audioCtx.resume();
  }

  return audioCtx;
};

// Hover Sound
const playHoverBlip = () => {
  const ctx = getAudioContext();
  const now = ctx.currentTime;

  const osc1 = ctx.createOscillator();
  const osc2 = ctx.createOscillator();
  const gain = ctx.createGain();

  osc1.type = 'sine';
  osc2.type = 'sine';

  osc1.frequency.setValueAtTime(1800, now);
  osc2.frequency.setValueAtTime(1850, now);

  const lfo = ctx.createOscillator();
  const lfoGain = ctx.createGain();

  lfo.frequency.value = 25;
  lfoGain.gain.value = 30;

  lfo.connect(lfoGain);
  lfoGain.connect(osc1.frequency);
  lfoGain.connect(osc2.frequency);

  gain.gain.setValueAtTime(0.06, now);
  gain.gain.exponentialRampToValueAtTime(0.001, now + 0.15);

  osc1.connect(gain);
  osc2.connect(gain);
  gain.connect(ctx.destination);

  lfo.start(now);
  osc1.start(now);
  osc2.start(now);

  lfo.stop(now + 0.15);
  osc1.stop(now + 0.15);
  osc2.stop(now + 0.15);
};

// Click Sound
const playClickWhoosh = () => {
  const ctx = getAudioContext();
  const now = ctx.currentTime;

  const osc = ctx.createOscillator();
  const gain = ctx.createGain();

  osc.type = 'sine';

  osc.frequency.setValueAtTime(180, now);
  osc.frequency.exponentialRampToValueAtTime(60, now + 0.2);

  gain.gain.setValueAtTime(0.3, now);
  gain.gain.exponentialRampToValueAtTime(0.001, now + 0.25);

  osc.connect(gain);
  gain.connect(ctx.destination);

  osc.start(now);
  osc.stop(now + 0.25);
};
  //ADD WALKING STATE VARIABLES
  const [walkToQuest, setWalkToQuest] = useState<string | null>(null);
  const [isWalking, setIsWalking] = useState(false);
  const lastWalkedDoorRef = useRef<string | null>(null);


  const progressforBadge = learnerPlayList.progress;
  const progressforBadgeInpercent = Math.floor(progressforBadge * 100);
    const [hasAssessment, setHasAssessment] = useState(false);
  const [questScores, setQuestScores] = useState(null);

const [isLastMilestoneQuest, setIsLastMilestoneQuest] = useState(false);

  const [hasClicked, setHasClicked] = useState(false);
  const { learner_game_play_id } = useParams();
  const useData = useContext(ProfileContext);
  const lastCompletionShownRef = useRef<string | null>(null);
  const [completedQuestVideo, setCompletedQuestVideo] = useState<string | null>(null);
// const questCompletionVideoMap: Record<string, string> = {
//   '1': preloadedAssets?.Quest1_Arms,
//   '2': preloadedAssets?.Quest2_Limbs,
//   '3': preloadedAssets?.Quest3_Brain,
//   '4': preloadedAssets?.Quest4_Heart
// };
const questCompletionVideoMap: Record<string, string> = {
  '1': Quest1_Arms,
  '2': Quest2_Limbs,
  '3': Quest3_Brain,
  '4':Quest4_Heart
};
 useEffect(() => {
    const allVideos = [
      ...Object.values(doorVideoMap),
      ...Object.values(questCompletionVideoMap)
    ];

    allVideos.forEach((src) => {
      if (!src) return;

      // Preload using link tag - removed fetchPriority
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'video';
      link.href = src;
      document.head.appendChild(link);

      // Fetch and cache as blob
      fetch(src)
        .then((res) => res.blob())
        .then((blob) => {
          const blobUrl = URL.createObjectURL(blob);
          if (!window._videoBlobCache) {
            window._videoBlobCache = new Map();
          }
          window._videoBlobCache.set(src, blobUrl);
        })
        .catch(() => {});
    });
  }, []);
useEffect(() => {
  fetchchapterQuestScore();

}, []);

const getScale = () => {
  const zoom = Math.round((window.outerWidth / window.innerWidth) * 100);

  const width = window.innerWidth;
  const height = window.innerHeight;

  // 🔥 BASE SCALE (zoom fix)
  let scale = 100 / zoom;

  // 🔥 SCREEN SIZE ADJUSTMENT
  if (width < 1280 || height < 800) {
    scale *= 0.85; // small laptops
  } else if (width > 1600) {
    scale *= 1.05; // large screens
  }

  return scale;
};

const [scale, setScale] = React.useState(getScale());

React.useEffect(() => {
  const handleResize = () => {
    setScale(getScale());
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);


  useEffect(() => {
    let GrandMaximumscore: any = {};
    let currentScores: any[];
    let getquest: any[];
    let maxScoreByQuest: { key: string; value: number }[] = [];
    profile?.score.map((profileQuest: any) => {
      if (!getquest?.includes(profileQuest?.quest)) {
        const scores = profile?.score;
        const sums: any = {};
        scores.forEach((score: any) => {
          const quest = score.quest;
          if (!sums[quest]) {
            sums[quest] = 0;
          }
          sums[quest] += score.score;
        });
        const getFinalscores = Object.entries(sums).map(([quest, score]) => ({
          quest,
          score,
        }));
        getquest = getFinalscores;
      }
    });
    const scores = profile?.score;
    const sums: any = {};
    scores?.forEach((score: any) => {
      const quest = score.quest;
      if (!sums[quest]) {
        sums[quest] = 0;
      }
      sums[quest] += score.score;
    });
    getquest?.map((profileQuest: any) => {
      if (sums[profileQuest?.quest] !== undefined) {
        currentScores = profile?.score;
      }
      const currentQuestseqId = Array.isArray(currentScores)
        ? currentScores.map((item) => item.seqId)
        : [];
      if (Array.isArray(currentScores) && currentScores.length > 0) {
        // Map currentScores to extract scores
        const scores = currentScores.map((item) => item.score);

        const result = currentQuestseqId?.map((seqId) => {
          const QuestNo = seqId?.split('.')[0];
          if (QuestNo == profileQuest?.quest) {
            const filteredOptions = gameInfo?.questOptions?.filter(
              (option: any) => option.qpSequence == seqId,
            );
            const qpScoresOption = filteredOptions.map((option: any) =>
              parseInt(option.qpScore),
            );
            qpScoresOption.sort((a: any, b: any) => b - a);
            if (!GrandMaximumscore[profileQuest?.quest]) {
              GrandMaximumscore[profileQuest?.quest] = 0;
            }
            GrandMaximumscore[profileQuest?.quest] += qpScoresOption[0];
          }
          maxScoreByQuest = { ...maxScoreByQuest, ...GrandMaximumscore };
        });
      } else {
      }
    });
    setQuestScores(maxScoreByQuest);
    const getQuestwisePlayerScore = async () => {
      let result: { [key: number]: number } = {};
      if (gameInfo?.blocks) {
        Object.keys(gameInfo?.blocks).forEach((it: any, num: number) => {
          // const scores = profile?.score;
          const scores =
            Object.entries(questState).length > 0
              ? questState[parseInt(profile?.currentQuest)] === 'Started'
                ? profile?.score
                : Object.entries(questState).length > 0
                ? questState[parseInt(profile?.currentQuest)] ===
                    'replayallowed' ||
                  questState[parseInt(profile?.currentQuest)] === 'completed'
                  ? profile?.replayScore.length > 0
                    ? profile?.replayScore
                    : profile?.score
                  : profile?.score
                : profile?.score
              : profile?.score;
          const sums: any = {};
          scores?.forEach((score: any) => {
            const quest = score.quest;
            if (!sums[quest]) {
              sums[quest] = 0;
            }
            sums[quest] += score.score;
          });

          let getFinalscores: any = {};
          Object.entries(sums).forEach(([quest, score]) => {
            const IntQuest = parseInt(quest);
            const newQuest = { ...getFinalscores, [IntQuest]: score };
            getFinalscores = { ...newQuest };
          });
          const TotalScore = Object.entries(getFinalscores).reduce(
            (tot: number, acc: any) => {
              if (it == acc[0]) {
                tot = acc[1];
                return tot;
              }
            },
            0,
          );
          result = {
            ...result,
            [parseInt(it)]: TotalScore ? TotalScore : getFinalscores[it],
          };
        });
      }
      return result;
    };

    getQuestwisePlayerScore().then((score: any) => {
      setQuestWisePlayerScore(score);
    });
  }, []);
  const { profile, setProfile,setlearnerActivityrec ,deviceInfo} = useContext(ScoreContext);
  useEffect(() => {
    const currentQuest = profile?.currentQuest;
    gameInfo?.gameQuest.map((item: any, index: number) => {
      const questNoAsString = item.gameQuestNo.toString();
      if (profile?.completedLevels?.includes(questNoAsString)) {
        const scores = profile?.score;
        if (scores !== undefined) {
          const sums: any = {};
          scores.forEach((score: any) => {
            const quest = score.quest;
            if (!sums[quest]) {
              sums[quest] = 0;
            }
            sums[quest] += score.score;
          });
          const getFinalscores = Object.entries(sums).map(([quest, score]) => ({
            quest,
            score,
          }));

          const getscores = getFinalscores.find(
            (row: any) => row.quest == item.gameQuestNo,
          );
          const finalscore = getscores?.score ?? 0;
         
          if (gameInfo?.gameData?.gameDisableOptionalReplays === 'false') {
          
            if (item?.gameIsSetMinPassScore === 'true') {
            
              const getminpassscore = item?.gameMinScore;
              if (
                finalscore >= getminpassscore &&
                finalscore < item?.gameTotalScore
              ) {
            
                if (Object.entries(questState).length === 0) {
                 
                  setQuestState((prevquestdataList: any) => ({
                    ...prevquestdataList,
                    [item.gameQuestNo]: 'Started',
                  }));
                }
              } else {
              
                if (finalscore !== undefined) {
                  const status =
                    gameInfo?.gameData?.gameDisableOptionalReplays === 'false'
                      ? 'replayallowed'
                      : 'completed';
                 
                  if (Object.entries(questState).length === 0) {
                  
                    setQuestState((prevquestdataList: any) => ({
                      ...prevquestdataList,
                      [item.gameQuestNo]: 'Started',
                    }));
                  }
                } else {
                 
                  setQuestState((prevquestdataList: any) => ({
                    ...prevquestdataList,
                    [item.gameQuestNo]: 'Started',
                  }));
                }
              }
            } else {
             
              if (finalscore !== undefined) {
               
              
                if (Object.entries(questState).length === 0) {
                 
                  setQuestState((prevquestdataList: any) => ({
                    ...prevquestdataList,
                    [item.gameQuestNo]: 'Started',
                  }));
                }
              } else {
              
                const scores =
                  profile?.playerGrandTotal?.questScores[currentQuest];
                if (scores === 0) {
                 
                  const status =
                    gameInfo?.gameData?.gameDisableOptionalReplays === 'false'
                      ? 'replayallowed'
                      : 'completed';
                  const finalscore = 0;
                  if (
                    finalscore === 0 &&
                    profile.compQuest.includes(questNoAsString)
                  ) {
                    if (item?.gameIsSetMinPassScore === 'false') {
                    
                      setQuestState((prevquestdataList: any) => ({
                        ...prevquestdataList,
                        [item.gameQuestNo]: status,
                      }));
                    }
                  }
                } else {
                 
                  setQuestState((prevquestdataList: any) => ({
                    ...prevquestdataList,
                    [item.gameQuestNo]: 'Started',
                  }));
                }
              }
            }
          } else {
            if (finalscore !== undefined) {
             
              if (Object.entries(questState).length === 0) {
                setQuestState((prevquestdataList: any) => ({
                  ...prevquestdataList,
                  [item.gameQuestNo]: 'Started',
                }));
              } else if (questState[item.gameQuestNo] === 'locked') {
               
                setQuestState((prevquestdataList: any) => ({
                  ...prevquestdataList,
                  [item.gameQuestNo]: 'Started',
                }));
              }
            } else {
             
              if (Object.entries(questState).length === 0) {
                setQuestState((prevquestdataList: any) => ({
                  ...prevquestdataList,
                  [item.gameQuestNo]: 'Started',
                }));
              }
            }
          }
        }
      } else {
        setQuestState((prevquestdataList: any) => ({
          ...prevquestdataList,
          [item.gameQuestNo]: 'locked',
        }));
      }
    });
  }, [profile]);

  //kaviya -new 
  // ==================== GAME PROGRESS LOCALSTORAGE UTILITIES ====================

interface QuestProgress {
  doorPlayed: boolean;
  dialogShown: boolean;
  completionVideoPlayed: boolean;
  completed: boolean;
  firstTimeCompleted: boolean;
}

interface GameProgress {
  gameId: string;
  learnerId: string;
  firstTimeCompleted: boolean; // used for Screen 16 vs Screen 13
  quests: Record<string, QuestProgress>;
    questOneDialogs?: any[];
  lastUpdated: string;
}
const getStorageKey = (gameId: string, learnerId: string) =>
  `gameProgress_${gameId}_${learnerId}`;

const getGameProgress = (): GameProgress | null => {
  const gameId = learnerPlayList?.GameId;
  const learnerId = learnerPlayList?.playerId;

  if (!gameId || !learnerId) return null;

  // const stored = localStorage.getItem(getStorageKey(gameId, learnerId));
  // if (!stored) return null;
  const key = getStorageKey(gameId, learnerId);
  const getstored = gameProgressData?.[key];
  if (!getstored) return null;
  try {
    return getstored as GameProgress;
    // return JSON.parse(stored) as GameProgress;
  } catch (e) {
    console.error("Error parsing game progress:", e);
    return null;
  }
};

const initializeGameProgress = (): GameProgress | null => {
 
  const gameId = learnerPlayList?.GameId;
  const learnerId = learnerPlayList?.playerId;
  const totalQuests = learnerPlayList?.questState?.length || 4;


  if (!gameId || !learnerId) return null;

  const quests: Record<string, QuestProgress> = {};

  for (let i = 1; i <= totalQuests+1; i++) {
    quests[String(i)] = {
      doorPlayed: false,
      dialogShown: false,
      completionVideoPlayed: false,
      completed: false,
      firstTimeCompleted: false,
    };
  }

  const progress: GameProgress = {
    gameId,
    learnerId,
    firstTimeCompleted: false,
    quests,
    lastUpdated: new Date().toISOString(),
  };
  setGameProgressData((prev: any) => ({
      ...prev,
      [getStorageKey(gameId, learnerId)]: progress,
  }))

  // localStorage.setItem(
  //   getStorageKey(gameId, learnerId),
  //   JSON.stringify(progress)
  // );

  return progress;
};

const saveGameProgress = (progress: GameProgress) => {
  const gameId = learnerPlayList?.GameId;
  const learnerId = learnerPlayList?.playerId;

  if (!gameId || !learnerId) return;

  progress.lastUpdated = new Date().toISOString();
  setGameProgressData((prev: any) => ({
      ...prev,
      [getStorageKey(gameId, learnerId)]: progress,
  }))
  // localStorage.setItem(
  //   getStorageKey(gameId, learnerId),
  //   JSON.stringify(progress)
  // );
};

const updateQuestProgress = (
  questNo: string,
  updates: Partial<QuestProgress>
): GameProgress | null => {
  let progress = getGameProgress();

  if (!progress) {
    progress = initializeGameProgress();
    if (!progress) return null;
  }

  const key = String(questNo);

  if (!progress.quests[key]) {
    // Safety fallback
    progress.quests[key] = {
      doorPlayed: false,
      dialogShown: false,
      completionVideoPlayed: false,
      completed: false,
      firstTimeCompleted: false,
    };
  }

  progress.quests[key] = {
    ...progress.quests[key],
    ...updates,
  };

  saveGameProgress(progress);
  return progress;
};

const markDoorPlayed = (questNo: string) =>
  updateQuestProgress(questNo, { doorPlayed: true });

const markDialogShown = (questNo: string) =>
  updateQuestProgress(questNo, { dialogShown: true });

const markCompletionVideoPlayed = (questNo: string) =>
  updateQuestProgress(questNo, { completionVideoPlayed: true });





const markGameFirstTimeCompleted = () => {
  const progress = getGameProgress();
  if (!progress) return null;

  progress.firstTimeCompleted = true;
  saveGameProgress(progress);

  return progress;
};
  //kaviya -new useEffect
useEffect(() => {
  if (!learnerPlayList?.GameId || !learnerPlayList?.playerId) return;
  
  let progress = getGameProgress();
  
  if (!progress) {
    progress = initializeGameProgress();
   
  } else {
 
  }
}, [learnerPlayList?.GameId, learnerPlayList?.playerId]);



useEffect(() => {
  if (!learnerPlayList || !learnerPlayList.Assessment) {
    setHasAssessment(false);
    return;
  }

  const assessmentData = learnerPlayList.Assessment;


  const hasPassedAssessment = assessmentData.some(
    (assessment:any) =>
      assessment.passed === "Yes" || Number(assessment.finalScore) >= 80
  );

  setHasAssessment(hasPassedAssessment);
}, [learnerPlayList]);

  const [playingDoorVideo, setPlayingDoorVideo] = useState<string | null>(null);
   const [isDoorVideoPaused, setIsDoorVideoPaused] = useState(false);
  const [isCompletionVideoPaused, setIsCompletionVideoPaused] = useState(false);
  const doorVideoRef = useRef<HTMLVideoElement>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const completionVideoRef = useRef<HTMLVideoElement>(null);
  const completionTimeoutRef = useRef<NodeJS.Timeout | null>(null);
const doorVideoMap: Record<string, string> = {
  '1': Door1,
  '2': Door2,
  '3':Door3,
  '4':Door4
};
// const doorVideoMap: Record<string, string> = {
//   '1': preloadedAssets?.Door1,
//   '2': preloadedAssets?.Door2,
//   '3':preloadedAssets?.Door3,
//   '4':preloadedAssets?.Door4,
// };
const [milestoneQuest, setMilestoneQuest] = useState<string | null>(null);

 const isQuestTransitionActive =
  !!completedQuestVideo || !!milestoneQuest;


const stopAllAudio = () => {
  // Stop all <audio> elements
  document.querySelectorAll('audio').forEach((audio) => {
    audio.pause();
    audio.currentTime = 0;
    audio.muted = true;
  });

  // Suspend existing AudioContext (if any)
  if ((window as any)._gameAudioCtx) {
    try {
      (window as any)._gameAudioCtx.suspend();
    } catch (e) {}
  }
};


const handleVideoComplete = () => {
  if (timeoutRef.current) {
    clearTimeout(timeoutRef.current);
  }

  const door = playingDoorVideo;

  setIsDoorTransition(true);
  markDoorPlayed(door);
  setIsDoorEntry?.(true);
  handleChapter(door);
};






const handleCompletionVideoComplete = () => {
  if (completionTimeoutRef.current) {
    clearTimeout(completionTimeoutRef.current);
  }

  const quest = completedQuestVideo;

  setIsDoorTransition(true);

  // mark as played
  markCompletionVideoPlayed(quest);

  setMilestoneQuest(quest);

  // clear state
  setCompletedQuestVideo(null);

  // resume audio
  if (audioObj) {
    if (typeof audioObj.play === 'function') audioObj.play();
    else if (typeof audioObj.mute === 'function') audioObj.mute(false);
  }

  if ((window as any)._gameAudioCtx) {
    try {
      (window as any)._gameAudioCtx.resume();
    } catch (e) {}
  }
};

const VIDEO_TIMEOUT = 15000;

// Door Video Timeout
const startDoorTimeout = () => {
  clearTimeoutHandler();

  timeoutRef.current = setTimeout(() => {
    handleVideoComplete();
  }, VIDEO_TIMEOUT);
};

const clearTimeoutHandler = () => {
  if (timeoutRef.current) {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = null;
  }
};
  useEffect(() => {
  if (!playingDoorVideo) return;

  const timer = setTimeout(() => {
    handleVideoComplete();
  }, 15000);

  return () => clearTimeout(timer);
}, [playingDoorVideo]);
// Completion Video Timeout
const startCompletionTimeout = () => {
  clearCompletionTimeout();

  completionTimeoutRef.current = setTimeout(() => {
    handleCompletionVideoComplete();
  }, VIDEO_TIMEOUT);
};

const clearCompletionTimeout = () => {
  if (completionTimeoutRef.current) {
    clearTimeout(completionTimeoutRef.current);
    completionTimeoutRef.current = null;
  }
};

useEffect(() => {
  if (doorVideoRef.current) {
    if (isDoorVideoPaused || isAnimationPaused) {
      doorVideoRef.current.pause();
    } else {
      doorVideoRef.current.play().catch(() => {});
    }
  }
}, [isDoorVideoPaused, isAnimationPaused]);

useEffect(() => {
  if (completionVideoRef.current) {
    if (isCompletionVideoPaused || isAnimationPaused) {
      completionVideoRef.current.pause();
    } else {
      completionVideoRef.current.play().catch(() => {});
    }
  }
}, [isCompletionVideoPaused, isAnimationPaused]);

useEffect(() => {
  if (!completedQuestVideo) return;

  const timer = setTimeout(() => {
    handleCompletionVideoComplete();
  }, 15000);

  return () => clearTimeout(timer);
}, [completedQuestVideo]);
const walkingAudioRef = useRef<HTMLAudioElement | null>(null);


useEffect(() => {
 
  if (!walkingAudioRef.current) return;

  const audio = walkingAudioRef.current;

  try {
    if (isWalking) {
     
      stopAllAudio();

      // play first time
      audio.play().catch(() => {});

      // 🔁 custom loop with delay
      audio.onended = () => {
        if (isWalking) {
          setTimeout(() => {
            audio.currentTime = 0;
            audio.play().catch(() => {});
          }, 50); // 50ms delay
        }
      };

    } else {
    
      audio.pause();
      audio.currentTime = 0;

      // remove loop
      audio.onended = null;
    }
  } catch (e) {}
}, [isWalking]);





useEffect(() => {
  if (!profile?.currentQuest) return;

  const questKey = `quest${profile.currentQuest}`;


  const shouldPlayCompletionVideo = () => {
    const progress = getGameProgress();
    
   
    return (
      completedVideoRef.current[questKey] && 
      !progress?.quests[profile.currentQuest]?.completionVideoPlayed
    );
  };


  if (shouldPlayCompletionVideo()) {
 
    setCompletedQuestVideo(String(profile.currentQuest));
  }
}, [profile?.currentQuest]);


const handleMilestoneContinue = () => { 
  if (!milestoneQuest) return;

  const totalQuests = Object.keys(learnerPlayList.questState).length;
  const questNo = Number(milestoneQuest);
  const isLastQuest = questNo === totalQuests;

 
  if (currentDialogs.length > 0 && !isDialogCompleted) {
 
    return;
  }

  
  if (isLastQuest && isDialogCompleted) {
    setCurrentScreenId(13);
    setMilestoneQuest(null);
    return;
  }

  // 3️⃣ Otherwise, move to next quest dialog
  const nextQuestNo = questNo + 1;
  const progress = getGameProgress();

  if (progress && progress.quests[String(nextQuestNo)]) {
    // Mark next quest as current so hubDialogQuestNo updates
    setProfile((prev:any) => ({ ...prev, currentQuest: nextQuestNo }));

    // Optionally, reset dialog index / current dialogs for new quest
    setCurrentDialogs([]);
    setDialogIndex(0);
    setIsDialogCompleted(false);

  }

  // Clear milestone for current quest
  setMilestoneQuest(null);
};



const numberToOrdinal = (n: number) => {
  switch (n) {
    case 1: return 'first';
    case 2: return 'second';
    case 3: return 'third';
    case 4: return 'fourth';
    default: return `${n}th`;
  }
};

 const handleChapter = async (it: any) => {
    if (hasClicked) return; // Prevent multiple executions
    setHasClicked(true);
    const questStatus = questState?.[it];
  setlearnerActivityrec((prev:any)=>
      updateScreenActivity(
        prev,
        13,
        "Chapterpage",
        deviceInfo,
        {
          quest: it,
        }
      )
    );
    const isUnlocked =
      questStatus === 'Started' ||
      questStatus === 'completed' ||
      questStatus === 'replayallowed';

    if (!isUnlocked) {
      console.warn('Blocked navigation to locked quest:', it);
      return; // ⛔ Stops BLACK SCREEN completely
    }
    if (isZoomComplete) {
      setIsZoomComplete(false);
    }

    setProfile((prev: any) => ({
      ...prev,
      currentQuest: it.toString(),
    }));

    const checkdata = {
      gameId: learner_game_play_id,
      questNo: parseInt(it),
    };
    const datas = JSON.stringify(checkdata);
    const lastBlockresult = await activitygetlastblock(datas);
    if (lastBlockresult.status !== 'Success') {
    
      setHasClicked(false);
      return false;
    } else if (
      gameInfo?.gameData?.gameDisableOptionalReplays === 'true' &&
      (questState[parseInt(it)] === 'completed' ||
        questState[parseInt(it)] === 'replayallowed')
    ) {
     
      if (questState[parseInt(it)] === 'replayallowed') {
        setQuestState((prevquestdataList: any) => ({
          ...prevquestdataList,
          [it]: 'completed',
        }));
      }

      setActivitydata(lastBlockresult?.data[0]?.galId);
    
      setCurrentQuestNo(parseInt(it));
      setCurrentScreenId(6);
      return false;
    } else {
     
      if (lastBlockresult.data.length !== 0) {
      
        // if (lastBlockresult.data[0]?.galBlockId !== null) {
        if (lastBlockresult.data[0]?.galblockleft !== null) {
          if (
            gameInfo?.gameData?.gameDisableOptionalReplays === 'false' &&
            (questState[parseInt(it)] === 'completed' ||
              questState[parseInt(it)] === 'replayallowed')
          ) {
          
            if (questState[parseInt(it)] === 'completed') {
              setQuestState((prevquestdataList: any) => ({
                ...prevquestdataList,
                [it]: 'replayallowed',
              }));
            }
          }
          const Blockidcontinueblockid = lastBlockresult.data[0].galBlockId;
          const Blockidcontinue = lastBlockresult.data[0].galblockleft;
         

          setActivitydata(lastBlockresult.data[0].galId);
          const selectedFindNext: any = Object.values(
            gameInfo?.blocks[it],
          )?.filter((item: any) => item?.blockSecondaryId == Blockidcontinue);
          const selectedFindNextblockId: any = Object.values(
            gameInfo?.blocks[it],
          )?.filter((item: any) => item?.blockSecondaryId == Blockidcontinueblockid);
        

          setCurrentQuestNo(it);
          let selectedNext: any;
        
          if (selectedFindNext.length > 0) {
             
          
                  //-----------------------------end---------------------
               
                 
            const getLeadsto =
              selectedFindNext[0]?.blockChoosen === 'Interaction'
                ? await getInteractionNavi(selectedFindNext[0], it)
                : selectedFindNext[0]?.blockLeadTo;
            const condition = ['Complete'];
            
            if((getLeadsto && condition.includes(getLeadsto)) && lastBlockresult.data[0]?.galQuestionState === "complete"){
                checkFunction(
                  getLeadsto,
                  selectedFindNext[0],
                  it,
                  gameInfo?.gameData?.gameDisableOptionalReplays,
                );
                //  checkCompletionBadge();
                return false;
            }
            else if(selectedFindNext[0]?.blockChoosen === "ScenarioCompletion"){
              setData(selectedFindNext[0]);
              setType(selectedFindNext[0]?.blockChoosen);
              setGameInfo((prev: any) => ({
                ...prev,
                interactionfeedback:selectedFindNext[0]?.interactionfeedback,
              }));
              const AllSeq = learnerPlayList?.Prevquestseq[it];
              if (AllSeq && AllSeq.length > 0) {
                AllSeq.pop();
                if (AllSeq && prevBlock.length === 0) {
                  setprevBlock(AllSeq);
                }
              }
              setCurrentScreenId(2);
              return false;
            }
            else if (selectedFindNext[0]?.blockChoosen === 'Interaction') {
              const optionsFiltered = [];

              for (const option of gameInfo?.questOptions) {
                if (profileData?.Audiogetlanguage.length > 0) {
                  if (
                    option?.qpSequence === selectedFindNext[0]?.blockPrimarySequence
                  ) {
                    const profilesetlan = profileData?.Audiogetlanguage.find(
                      (key: any) => key?.textId === option.qpOptionId,
                    );

                    if (profilesetlan) {
                      const languagecont = {
                        ...option,
                        qpOptionText: profilesetlan.content,
                      };
                      optionsFiltered.push(languagecont);
                    } else {
                      optionsFiltered.push(option);
                    }
                  }
                } else {
                  if (
                    option?.qpSequence === selectedFindNext[0]?.blockPrimarySequence
                  ) {
                    optionsFiltered.push(option);
                  }
                }
              }
              if (gameInfo?.gameData?.gameShuffle === 'true') {
                for (let i = optionsFiltered.length - 1; i > 0; i--) {
                  const j = Math.floor(Math.random() * (i + 1));
                  [optionsFiltered[i], optionsFiltered[j]] = [
                    optionsFiltered[j],
                    optionsFiltered[i],
                  ];
                }
              }
              setOptions(optionsFiltered);
              setData(selectedFindNext[0]);
              setType(selectedFindNext[0]?.blockChoosen);
              const AllSeq = learnerPlayList?.Prevquestseq[it];
              if (AllSeq && AllSeq.length > 0) {
                AllSeq.pop();
                if (AllSeq && prevBlock.length === 0) {
                  setprevBlock(AllSeq);
                }
              }
              setCurrentScreenId(2);
              return false;
            }
             else {
              setData(selectedFindNext[0]);
              setType(selectedFindNext[0]?.blockChoosen);
              setGameInfo((prev: any) => ({
                ...prev,
                interactionfeedback:selectedFindNext[0]?.interactionfeedback,
              }));
              const AllSeq = learnerPlayList?.Prevquestseq[it];
              if (AllSeq && AllSeq.length > 0) {
                AllSeq.pop();
                if (AllSeq && prevBlock.length === 0) {
                  setprevBlock(AllSeq);
                }
              }
              setCurrentScreenId(2);
              return false;
            }
            
          } else {
            setLearnerPlayingDetails((prev: any) => {
              const updatedPrevquestseq = { ...prev.Prevquestseq };
              if (updatedPrevquestseq[it]) {
                delete updatedPrevquestseq[it];
              }
              return {
                ...prev,
                Prevquestseq: updatedPrevquestseq,
              };
            });
            setprevBlock([]);

            if (profile?.completedLevels?.includes(it)) {
               const getprogressallScores = {
                  ...(gameProgressData?.scenarioScores || {})
                };
                if(getprogressallScores[parseInt(it)]!== undefined){
                  // remove current quest scores
                  delete getprogressallScores[parseInt(it)];
                }
                  // update state
                  setGameProgressData((prev: any) => ({
                    ...prev,
                    scenarioScores: getprogressallScores,
                  }));
              setType(gameInfo?.blocks[it]['1']?.blockChoosen);
              setData(gameInfo?.blocks[it]['1']);
              if (gameInfo?.blocks[it]['1']?.blockChoosen === 'Interaction') {
                const optionsFiltered = [];
                const primarySequence =
                  gameInfo?.blocks[it]['1'].blockPrimarySequence;
                for (const option of gameInfo?.questOptions) {
                  if (profileData?.Audiogetlanguage.length > 0) {
                    if (option?.qpSequence === primarySequence) {
                      const profilesetlan = profileData?.Audiogetlanguage.find(
                        (key: any) => key?.textId === option.qpOptionId,
                      );
                      if (profilesetlan) {
                        const languagecont = {
                          ...option,
                          qpOptionText: profilesetlan.content,
                        };
                        optionsFiltered.push(languagecont);
                      } else {
                        optionsFiltered.push(option);
                      }
                    }
                  } else {
                    if (option?.qpSequence === primarySequence) {
                      optionsFiltered.push(option);
                    }
                  }
                }
                if (gameInfo?.gameData?.gameShuffle === 'true') {
                  for (let i = optionsFiltered.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [optionsFiltered[i], optionsFiltered[j]] = [
                      optionsFiltered[j],
                      optionsFiltered[i],
                    ];
                  }
                }
                setOptions(optionsFiltered);
              }
              setProfile((prev: any) => {
                const data = { ...prev };
                if (
                  questState[parseInt(it)] !== 'replayallowed' &&
                  profile?.score.length > 0
                ) {
                  data.score = profile?.score?.filter(
                    (item: any) => item.quest !== parseInt(it),
                  );
                }

                if (profile.completedLevels.length === 0) {
                  data.completedLevels = [String(it)];
                } else if (
                  !profile.completedLevels.includes(String(it)) &&
                  profile.completedLevels.length !== 0
                ) {
                  data.completedLevels = [...data.completedLevels, String(it)];
                }
                return data;
              });
              setCurrentScreenId(2);
            }
            return false;
          }
        } else {
          setLearnerPlayingDetails((prev: any) => {
            const updatedPrevquestseq = { ...prev.Prevquestseq };
            if (updatedPrevquestseq[it]) {
              delete updatedPrevquestseq[it];
            }
            return {
              ...prev,
              Prevquestseq: updatedPrevquestseq,
            };
          });
          setprevBlock([]);
          if (profile?.score.length > 0) {
            setProfile((prev: any) => {
              const data = { ...prev };
              if (
                questState[parseInt(it)] !== 'replayallowed' &&
                profile?.score.length > 0
              ) {
                data.score = profile?.score?.filter(
                  (item: any) => item.quest !== parseInt(it),
                );
              }

              return data;
            });
          }
          const data = {
            gameId: learner_game_play_id,
            questNo: parseInt(it),
            galBlockId: '',
            galblocklef:'',
            averageScore: 0,
            galAssignedId: AssignId,
          };
          const getdata = JSON.stringify(data);

          const result = await activityCreate(getdata);
          if (result.status !== 'Success') {
            return false;
          } else {
            if (
              gameInfo?.gameData?.gameDisableOptionalReplays === 'false' &&
              (questState[parseInt(it)] === 'completed' ||
                questState[parseInt(it)] === 'replayallowed')
            ) {
              if (questState[parseInt(it)] === 'completed') {
                setQuestState((prevquestdataList: any) => ({
                  ...prevquestdataList,
                  [it]: 'replayallowed',
                }));
              }
            }
            if (profile?.score.length > 0) {
              setProfile((prev: any) => {
                const data = { ...prev };
                if (
                  questState[parseInt(it)] !== 'replayallowed' &&
                  profile?.score.length > 0
                ) {
                  data.score = profile?.score?.filter(
                    (item: any) => item.quest !== parseInt(it),
                  );
                }

                return data;
              });
            }
            setCurrentQuestNo(it);
            setActivitydata(result.data);
            if (profile?.completedLevels?.includes(it)) {
               const getprogressallScores = {
                  ...(gameProgressData?.scenarioScores || {})
                };
                if(getprogressallScores[parseInt(it)]!== undefined){
                  // remove current quest scores
                  delete getprogressallScores[parseInt(it)];
                }
                  // update state
                  setGameProgressData((prev: any) => ({
                    ...prev,
                    scenarioScores: getprogressallScores,
                  }));
              setType(gameInfo?.blocks[it]['1']?.blockChoosen);
              setData(gameInfo?.blocks[it]['1']);
              if (gameInfo?.blocks[it]['1']?.blockChoosen === 'Interaction') {
                const optionsFiltered = [];
                const primarySequence =
                  gameInfo?.blocks[it]['1'].blockPrimarySequence;
                for (const option of gameInfo?.questOptions) {
                  if (profileData?.Audiogetlanguage.length > 0) {
                    if (option?.qpSequence === primarySequence) {
                      const profilesetlan = profileData?.Audiogetlanguage.find(
                        (key: any) => key?.textId === option.qpOptionId,
                      );
                      if (profilesetlan) {
                        const languagecont = {
                          ...option,
                          qpOptionText: profilesetlan.content,
                        };
                        optionsFiltered.push(languagecont);
                      } else {
                        optionsFiltered.push(option);
                      }
                    }
                  } else {
                    if (option?.qpSequence === primarySequence) {
                      optionsFiltered.push(option);
                    }
                  }
                }
                if (gameInfo?.gameData?.gameShuffle === 'true') {
                  for (let i = optionsFiltered.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [optionsFiltered[i], optionsFiltered[j]] = [
                      optionsFiltered[j],
                      optionsFiltered[i],
                    ];
                  }
                }
                setOptions(optionsFiltered);
              }
              setProfile((prev: any) => {
                const data = { ...prev };
                if (profile.completedLevels.length === 0) {
                  data.completedLevels = [String(it)];
                } else if (
                  !profile.completedLevels.includes(String(it)) &&
                  profile.completedLevels.length !== 0
                ) {
                  data.completedLevels = [...data.completedLevels, String(it)];
                }
                return data;
              });
              setCurrentScreenId(2);
            }
            return false;
          }
        }
      } else {
        setLearnerPlayingDetails((prev: any) => {
          const updatedPrevquestseq = { ...prev.Prevquestseq };
          if (updatedPrevquestseq[it]) {
            delete updatedPrevquestseq[it];
          }
          return {
            ...prev,
            Prevquestseq: updatedPrevquestseq,
          };
        });
        setprevBlock([]);
        if (profile?.score.length > 0) {
          setProfile((prev: any) => {
            const data = { ...prev };
            if (
              questState[parseInt(it)] !== 'replayallowed' &&
              profile?.score.length > 0
            ) {
              data.score = profile?.score?.filter(
                (item: any) => item.quest !== parseInt(it),
              );
            }

            return data;
          });
        }
        const data = {
          gameId: learner_game_play_id,
          questNo: parseInt(it),
          galBlockId: '',
          galblockleft:'',
          averageScore: 0,
          galAssignedId: AssignId,
        };
        const datas = JSON.stringify(data);

        const result = await activityCreate(datas);
        if (result.status !== 'Success') {
          return false;
        } else if (
          gameInfo?.gameData?.gameDisableOptionalReplays === 'false' &&
          (questState[parseInt(it)] === 'completed' ||
            questState[parseInt(it)] === 'replayallowed')
        ) {
          if (questState[parseInt(it)] === 'completed') {
            setQuestState((prevquestdataList: any) => ({
              ...prevquestdataList,
              [it]: 'replayallowed',
            }));
          }
        }
        if (profile?.score.length > 0) {
          setProfile((prev: any) => {
            const data = { ...prev };
            if (
              questState[parseInt(it)] !== 'replayallowed' &&
              profile?.score.length > 0
            ) {
              data.score = profile?.score?.filter(
                (item: any) => item.quest !== parseInt(it),
              );
            }

            return data;
          });
        }
        setCurrentQuestNo(it);
        setActivitydata(result.data);
        if (profile?.completedLevels?.includes(it)) {
           const getprogressallScores = {
                  ...(gameProgressData?.scenarioScores || {})
                };
                if(getprogressallScores[parseInt(it)]!== undefined){
                  // remove current quest scores
                  delete getprogressallScores[parseInt(it)];
                }
                  // update state
                  setGameProgressData((prev: any) => ({
                    ...prev,
                    scenarioScores: getprogressallScores,
                  }));
          setType(gameInfo?.blocks[it]['1']?.blockChoosen);
          setData(gameInfo?.blocks[it]['1']);
          if (gameInfo?.blocks[it]['1']?.blockChoosen === 'Interaction') {
            const optionsFiltered = [];
            const primarySequence =
              gameInfo?.blocks[it]['1'].blockPrimarySequence;
            for (const option of gameInfo?.questOptions) {
              if (profileData?.Audiogetlanguage.length > 0) {
                if (option?.qpSequence === primarySequence) {
                  const profilesetlan = profileData?.Audiogetlanguage.find(
                    (key: any) => key?.textId === option.qpOptionId,
                  );
                  if (profilesetlan) {
                    const languagecont = {
                      ...option,
                      qpOptionText: profilesetlan.content,
                    };
                    optionsFiltered.push(languagecont);
                  } else {
                    optionsFiltered.push(option);
                  }
                }
              } else {
                if (option?.qpSequence === primarySequence) {
                  optionsFiltered.push(option);
                }
              }
            }
            if (gameInfo?.gameData?.gameShuffle === 'true') {
              for (let i = optionsFiltered.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [optionsFiltered[i], optionsFiltered[j]] = [
                  optionsFiltered[j],
                  optionsFiltered[i],
                ];
              }
            }
            setOptions(optionsFiltered);
          }
          setProfile((prev: any) => {
            const data = { ...prev };
            if (profile.completedLevels.length === 0) {
              data.completedLevels = [String(it)];
            } else if (
              !profile.completedLevels.includes(String(it)) &&
              profile.completedLevels.length !== 0
            ) {
              data.completedLevels = [...data.completedLevels, String(it)];
            }
            return data;
          });
          setCurrentScreenId(2);
        }
      }
    }
    for (let values in questState) {
      if (values === it) {
        if (questState[it] !== 'Locked') {
          useData?.setMotionEffect(true);
        } else {
          useData?.setMotionEffect(false);
        }
      }
    }

    setTimeout(() => setHasClicked(false), 10000); // Reset after 3s if needed
  };
 
  const handleWalkComplete = useCallback(() => {
 
  
  // Use the ref value which won't be affected by state resets
  const completedDoor = lastWalkedDoorRef.current;

  
  if (!completedDoor) {
    console.error('ERROR: No quest number found in ref!');
    return;
  }
 
  
  // Clear the ref
  lastWalkedDoorRef.current = null;
  
  // Reset walking states
  setIsWalking(false);
  setWalkToQuest(null);
  setHasClicked(false);
  setPlayingDoorVideo(completedDoor);
 
},[handleChapter]);


  const getPrevSelectedOption = (selectedFindNext: any) => {
    const scores =
      Object.entries(questState).length > 0
        ? questState[parseInt(profile?.currentQuest)] === 'Started'
          ? profile?.score
          : Object.entries(questState).length > 0
          ? questState[parseInt(profile?.currentQuest)] === 'replayallowed' ||
            questState[parseInt(profile?.currentQuest)] === 'completed'
            ? profile?.replayScore.length > 0
              ? profile?.replayScore
              : profile?.score
            : profile?.score
          : profile?.score
        : profile?.score;
    const foundNavi = scores?.filter(
      (item: any) => item.seqId == selectedFindNext?.blockPrimarySequence,
    );
    if (foundNavi.length > 0) {
      return foundNavi[0]?.choosedoption;
    } else {
      return null;
    }
  };
  const getInteractionNavi = (getBlocks: any, Quest: any) => {
    const scoreArray =
      Object.entries(questState).length > 0
        ? questState[parseInt(profile?.currentQuest)] === 'Started'
          ? profile?.score
          : Object.entries(questState).length > 0
          ? questState[parseInt(profile?.currentQuest)] === 'replayallowed' ||
            questState[parseInt(profile?.currentQuest)] === 'completed'
            ? profile?.replayScore
            : profile?.score
          : profile?.score
        : profile?.score;
    const foundNavi = scoreArray?.filter(
      (item: any) => item.seqId == getBlocks?.blockPrimarySequence,
    );
    if (foundNavi.length > 0) {
      const optionsFiltered = [];

      for (const option of gameInfo?.questOptions) {
        if (option?.qpSequence === getBlocks?.blockPrimarySequence) {
          optionsFiltered.push(option);
        }
      }
      // item?.qpNextOption
      if (optionsFiltered) {
        const getFilterOption = optionsFiltered.filter(
          (item: any) => item?.qpOptions === foundNavi[0]?.choosedoption,
        );
        if (getFilterOption) {
          return getFilterOption[0]?.qpNextOption;
        } else {
          return null;
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  const checkFunction = async (
    getLeadsto: any,
    selectedFindNext: any,
    Quest: any,
    gameDisableOptionalReplays: any,
  ) => {
    const nextLevel = parseInt(Quest) + 1 || null;
    if (
      getLeadsto === 'Repeat Question' &&
      selectedFindNext?.blockChoosen === 'Interaction'
    ) {
      setFeed('');
      setRepeatSelectOption(true);
      const getOption = await getPrevSelectedOption(selectedFindNext);
      if (getOption) {
        RepeatPrevOption.push(getOption);
      }
      setRepeatPrevOption(RepeatPrevOption);
      setType(selectedFindNext?.blockChoosen);
      setData(selectedFindNext);
      if (selectedFindNext?.blockChoosen === 'Interaction') {
        const optionsFiltered = [];
        for (const option of gameInfo.questOptions) {
          if (profileData?.Audiogetlanguage.length > 0) {
            if (option?.qpSequence === selectedFindNext?.blockPrimarySequence) {
              const profilesetlan = profileData?.Audiogetlanguage.find(
                (key: any) => key?.textId === option.qpOptionId,
              );
              if (profilesetlan) {
                const languagecont = {
                  ...option,
                  qpOptionText: profilesetlan.content,
                };
                optionsFiltered.push(languagecont);
              } else {
                optionsFiltered.push(option);
              }
            }
          } else {
            if (option?.qpSequence === selectedFindNext?.blockPrimarySequence) {
              optionsFiltered.push(option);
            }
          }
        }
        if (gameInfo?.gameData?.gameShuffle === 'true') {
          for (let i = optionsFiltered.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [optionsFiltered[i], optionsFiltered[j]] = [
              optionsFiltered[j],
              optionsFiltered[i],
            ];
          }
        }
        setOptions(optionsFiltered);
      }
      setCurrentScreenId(2);
      return false;
    } else if (
      getLeadsto === 'Repeat Question' &&
      selectedFindNext?.blockChoosen !== 'Interaction'
    ) {
      if (selectedFindNext?.blockChoosen === 'Interaction') {
        const optionsFiltered = [];
        for (const option of gameInfo.questOptions) {
          if (profileData?.Audiogetlanguage.length > 0) {
            if (option?.qpSequence === selectedFindNext?.blockPrimarySequence) {
              const profilesetlan = profileData?.Audiogetlanguage.find(
                (key: any) => key?.textId === option.qpOptionId,
              );
              if (profilesetlan) {
                const languagecont = {
                  ...option,
                  qpOptionText: profilesetlan.content,
                };
                optionsFiltered.push(languagecont);
              } else {
                optionsFiltered.push(option);
              }
            }
          } else {
            if (option?.qpSequence === selectedFindNext?.blockPrimarySequence) {
              optionsFiltered.push(option);
            }
          }
        }
        if (gameInfo?.gameData?.gameShuffle === 'true') {
          for (let i = optionsFiltered.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [optionsFiltered[i], optionsFiltered[j]] = [
              optionsFiltered[j],
              optionsFiltered[i],
            ];
          }
        }
        setOptions(optionsFiltered);
      }
      setType(selectedFindNext?.blockChoosen);
      setData(selectedFindNext);
      setCurrentScreenId(2);
      return false;
    } else if (getLeadsto === 'Replay Point') {
      // setReplayState('replayPointPrompt');
      // setReplayIsOpen(true);
      handleReplayButtonClick('replayPointPrompt');
      setCurrentQuestNo(Quest);
      setCurrentScreenId(2);
      return false;
    } else if (getLeadsto === 'Complete') {
      checkCompletionBadge();
      if (gameInfo?.blocks.hasOwnProperty(nextLevel)) {
        setProfile((prev: any) => {
          const data = { ...prev };
          if (profile.compQuest.length === 0) {
            data.compQuest = [String(profile?.currentQuest)];
          } else if (
            !profile.compQuest.includes(String(profile?.currentQuest))
          ) {
            data.compQuest = [...data.compQuest, String(profile?.currentQuest)];
          }
          if (!profile.completedLevels.includes(String(nextLevel))) {
            data.completedLevels = [...data.completedLevels, String(nextLevel)];
          }
          return data;
        });
      } else {
        setProfile((prev: any) => {
          const data = { ...prev };
          if (profile.compQuest.length === 0) {
            data.compQuest = [String(profile?.currentQuest)];
          } else if (
            !profile.compQuest.includes(String(profile?.currentQuest))
          ) {
            data.compQuest = [...data.compQuest, String(profile?.currentQuest)];
          }
          return data;
        });
      }
      if (gameDisableOptionalReplays === 'false') {
        handleReplayButtonClick('optionalReplay');
        //  setCurrentScreenId(6);
        // setType(null);
        // setData(null);
        return false;
      } else {
        setCurrentScreenId(6);
        setType(null);
        setData(null);
        return false;
      }
    } else {
      if (gameDisableOptionalReplays === 'false') {
        handleReplayButtonClick('optionalReplay');
        //    setCurrentScreenId(6);
        // setType(null);
        // setData(null);
        return false;
      } else {
        setCurrentScreenId(6);
        setType(null);
        setData(null);
        return false;
      }
    }
  };

const allQuestsCompleted =
  learnerPlayList?.questState &&
  Object.values(learnerPlayList.questState).every(
    (state) => state === "replayallowed"
  );

const assessmentAttempted =
  learnerPlayList?.Assessment?.[0]?.attemptNumber >= 1;


const handleCertificateClick = () => {

  setCurrentScreenId(18); // move to certificate screen
};



  const [doorToast, setDoorToast] = useState<{
    questId: string;
    message: string;
  } | null>(null);



const [showUnlockOverlay, setShowUnlockOverlay] = useState(false);
const [unlockedQuest, setUnlockedQuest] = useState<string | null>(null);

const unlockShownRef = useRef<Set<string>>(new Set());





const handleQuestClickWithValidation = (it: string) => {
  const questNo = parseInt(it);
  const totalQuests = gameInfo?.gameQuest?.length || 0;

  // 0️⃣ CLICK BLINK EFFECT
  const hit = document.getElementById(`door${it}-hit`);
  if (hit) {
    hit.classList.add('is-clicked');
    setTimeout(() => {
      hit.classList.remove('is-clicked');
    }, 250);
  }

  // 1️⃣ Quest does not exist
  if (questNo > totalQuests) {
    setDoorToast({ questId: it, message: `Quest ${questNo} Locked` });
    setTimeout(() => setDoorToast(null), 2000);
    return;
  }

    // 2️⃣ Check ALL previous quests completion
    if (questNo !== 1) {
      const missingQuests: string[] = [];

      for (let i = 1; i < questNo; i++) {
        const q = String(i);
        if (!profile?.completedLevels?.includes(q)) {
          missingQuests.push(`Quest ${i}`);
        }
      }

      if (missingQuests.length > 0) {
        const lastMissing = missingQuests[missingQuests.length - 1];

        
      setDoorToast({
        questId: it,
        message: 'This quest is currently locked',
      });
      setTimeout(() => setDoorToast(null), 2000);
        return;
      }
    }

    // 3️⃣ Safety check using questState also
    const questStatus = questState?.[it];
    const isUnlocked =
      questStatus === 'Started' ||
      questStatus === 'completed' ||
      questStatus === 'replayallowed';
  const isFirstQuest = questNo === 1;
  const prevQuestCompleted = questNo === 1 ? true : isQuestCompleted(questNo - 1);
  const canAccess = isFirstQuest || prevQuestCompleted || questStatus === 'Started';

  if (!canAccess || !isUnlocked) {
   
    setDoorToast({
      questId: it,
      message: 'This quest is currently locked',
    });
    setTimeout(() => setDoorToast(null), 2000);
    return;
  }

    // ✅ All validations passed
    setDoorToast(null);
  if (isWalking) {
   
    return;
  }
  
  const shouldShowOverlay =
    questState?.[it] === 'Started' && !unlockShownRef.current.has(it);

  if (shouldShowOverlay) {
    unlockShownRef.current.add(it);

    setUnlockedQuest(it);
    setShowUnlockOverlay(true);

    setTimeout(() => {
      setShowUnlockOverlay(false);
      
      // CHECK IF DOOR VIDEO SHOULD PLAY
      const progress = getGameProgress();
      // const shouldPlayDoor = !progress?.quests[it]?.doorPlayed;
      const questKey = String(it);
const shouldPlayDoor = !progress?.quests[questKey]?.doorPlayed;
      
      if (shouldPlayDoor) {
        // MARK DOOR AS PLAYED
        // markDoorPlayed(it);
        lastWalkedDoorRef.current = it;
        setWalkToQuest(it);
        setIsWalking(true);
        setHasClicked(true);
      } else {
        // SKIP DOOR VIDEO, GO DIRECTLY TO CHAPTER
        lastWalkedDoorRef.current = it;
        setWalkToQuest(it);
        setIsWalking(true);
        setHasClicked(true);

         setTimeout(() => {
              setIsDoorEntry?.(true);
              sessionStorage.setItem("showQuestTransition", "true");
              handleChapter(parseInt(it));
            }, 600); // small delay so walk animation finishes
      }
    }, 1800);

    return;
  }
  
  // CHECK IF DOOR VIDEO SHOULD PLAY
  const progress = getGameProgress();
  const shouldPlayDoor = !progress?.quests[it]?.doorPlayed;
  
  // Store the door in the ref BEFORE setting state
  lastWalkedDoorRef.current = it;
  
  if (shouldPlayDoor) {
    // MARK DOOR AS PLAYED
    // markDoorPlayed(it);
    // Set walkToQuest FIRST - this is what QuestHubLab is listening for
    setWalkToQuest(it);
    
    // Then set isWalking
    setIsWalking(true);
    
    // Set hasClicked to prevent immediate execution
    setHasClicked(true);
  } else {
    // SKIP DOOR VIDEO, GO DIRECTLY TO CHAPTER AFTER WALK
    setWalkToQuest(it);
    setIsWalking(true);
    setHasClicked(true);
  }


};

 const DoorToast = ({ message }: { message: string }) => (
    <Box
      position="absolute"
      top="-68px"
      left="50%"
      transform="translateX(-50%)"
      minW="160px"
      maxW="260px"
      px="16px"
      py="12px"
      textAlign="center"
      borderRadius="10px" // ✅ Square rounded like your image
      fontSize="12px"
      fontWeight="600"
      letterSpacing="0.4px"
      whiteSpace="normal"
      zIndex={1000}
      /* ✅ SAME QUESTHUB NEON COLORS */
      bg="rgba(10, 15, 30, 0.9)"
      color="#3CFFC6"
      border="2px solid #3CFFC6"
      backdropFilter="blur(6px)"
      boxShadow="
      0 0 10px rgba(60,255,198,0.8),
      0 0 25px rgba(60,255,198,0.5),
      inset 0 0 10px rgba(60,255,198,0.4)
    "
    >
      {message}

      {/* ✅ BOTTOM POINTER (LIKE YOUR IMAGE) */}
      <Box
        position="absolute"
        bottom="-12px"
        left="50%"
        transform="translateX(-50%) rotate(45deg)"
        width="18px"
        height="18px"
        bg="rgba(10, 15, 30, 0.95)"
        borderRight="2px solid #3CFFC6"
        borderBottom="2px solid #3CFFC6"
        boxShadow="0 0 10px rgba(60,255,198,0.8)"
      />
    </Box>
  );

 useEffect(() => {
    if (!doorToast) return;

    const timer = setTimeout(() => {
      setDoorToast(null);
    },10000);

    return () => clearTimeout(timer);
  }, [doorToast?.questId]);



useEffect(() => {
  if (
    
    playingDoorVideo
  ) {
    stopAllAudio();
  }
}, [
 
  playingDoorVideo,
 
]);


useEffect(() => {
  if (!completedQuestVideo || !audioObj) return;

  stopAllAudio();

  // Handle different audio types safely
  if (typeof audioObj.pause === "function") {
    audioObj.pause();
    audioObj.currentTime = 0;
  } 
  else if (typeof audioObj.stop === "function") {
    audioObj.stop();
  } 
  else if (typeof audioObj.mute === "function") {
    audioObj.mute(true);
  }
}, [completedQuestVideo, audioObj]);
// useEffect(() => {
//   if (
    
  
//     completedQuestVideo
//   ) {
//     stopAllAudio();
//   }
// }, [
 

//   completedQuestVideo,
// ]);
useEffect(() => {
  if ((playingDoorVideo) && audioObj) {
    try {
      audioObj.pause();
      audioObj.currentTime = 0; // optional: reset
    } catch (e) {}
  }
}, [playingDoorVideo]);
// useEffect(() => {
//   if ((completedQuestVideo) && audioObj) {
//     try {
//       audioObj.pause();
//       audioObj.currentTime = 0; // optional: reset
//     } catch (e) {}
//   }
// }, [completedQuestVideo]);



  const [gameDialogs, setGameDialogs] = useState<any>({});
  const [currentDialogs, setCurrentDialogs] = useState<any[]>([]);
  const [dialogIndex, setDialogIndex] = useState(0);
const [certificateUnlocked, setCertificateUnlocked] = useState(false);








  const hubDialogQuestNo = useMemo(() => {
  const completedMap = completedVideoRef.current;

  if (!completedMap) return 1;

  // Extract completed quest numbers
  const completedQuests = Object.keys(completedMap)
    .filter(key => completedMap[key] === true)
    .map(key => Number(key.replace('quest', '')))
    .filter(num => !isNaN(num));

  // No videos completed yet
  if (completedQuests.length === 0) {
    return 1;
  }

  // Next quest after last completed video
  return Math.max(...completedQuests) + 1;
}, [profile?.currentQuest]);


   
const [curretQuestOptions, setCurrentQuestOptions] = useState(
      gameInfo?.gameQuest?.find(
        (quest: any) => quest?.gameQuestNo == profile?.currentQuest,
      ),
    );

      const dialog = currentDialogs[dialogIndex] || {};
  
    const displayText = dialog.text || "";
    // const characterName = dialog.characters || "";
  //   const characterName =
  // (dialog.characters || "").trim().toLowerCase() === "player"
  //   ? learnerPlayList?.LearnerProfile?.nickName
  //   : learnerPlayList?.mentorName;
  const characterName =
  (dialog.characters || "").trim().toLowerCase() === "player"
    ? learnerPlayList?.LearnerProfile?.nickName
    : learnerPlayList?.mentorName ||
      (learnerPlayList?.selectedmentor_charcter === "MaleMentor"
        ? "Zane"
        : learnerPlayList?.selectedmentor_charcter === "FemaleMentor"
          ? "Elara"
          : "");
    const playerName = learnerPlayList?.LearnerProfile?.nickName || "";
    const mentorName = learnerPlayList?.mentorName || "";
    const playerGender =  learnerPlayList?.player_gender?.toLowerCase();
    const mentorgender =  learnerPlayList?.mentor_gender?.toLowerCase();
    const selectedplayer = learnerPlayList?.selectedplayer_charcter
 
    const selectedmentor = learnerPlayList?.selectedmentor_charcter

// ## avatar mapping



 

   const playerAvatar =
  selectedplayer === "FutureThemeMale"
    ? MalePlayer2
    : selectedplayer === "FutureThemeFemale"
    ? FemalePlayer2
    : selectedplayer === "FutureThemeMale1"
    ? MalePlayer3
    : selectedplayer === "FutureThemeFemale1"
    ? FemalePlayer3
    : selectedplayer === "FuturisticMaleUser"
    ? FutureMale
    : selectedplayer === "FuturisticFemaleUser"
    ? Futurefemale
    : "";


    const mentorAvatar =
  selectedmentor === "FemaleMentor"
    ? FemaleMentor
    : selectedmentor === "MaleMentor"
    ? MaleMentor
    : "";


const isPlayer =
  (dialog.characters || "").trim().toLowerCase() === "player";
const selectedPlayer = learnerPlayList?.selectedplayer_charcter;

  const currentGameId = gameInfo?.gameId;


const audioUrl = useMemo(() => {

 

  if (!dialog) return "";

  const speaker = (dialog.characters || "").trim().toLowerCase();


  let rawAudio = "";

  if (speaker === "player") {

    const femalePlayers = [
      "FuturisticFemaleUser",
      "FutureThemeFemale",
      "FutureThemeFemale1"
    ];

    const isFemalePlayer = femalePlayers.includes(selectedplayer);

   

    rawAudio = isFemalePlayer ? dialog?.femalevoice : dialog?.audio;

  } 
  else if (speaker === "mentor" || speaker === "npc") {

    const isFemaleMentor = mentorgender?.toLowerCase() === "female";

  

    rawAudio = isFemaleMentor ? dialog?.femalevoice : dialog?.audio;

  } 
  else {
    rawAudio = dialog?.audio;
  }

 

  if (!rawAudio) return "";

  if (rawAudio.startsWith("http")) return rawAudio;

  const baseUrl = API_SERVER.endsWith("/")
    ? API_SERVER.slice(0, -1)
    : API_SERVER;

  const audioPath = rawAudio.startsWith("/")
    ? rawAudio
    : `/${rawAudio}`;

  return `${baseUrl}${audioPath}`;

}, [dialog, selectedplayer, mentorgender]);
useEffect(() => {
  if (currentDialogs.length > 0) {
    setDialogIndex(0);
    setIsDialogCompleted(false); // 👈 IMPORTANT
  }
}, [currentDialogs]);
  // ----------------------------------------------------
  // ## FETCH API DATA
  // ----------------------------------------------------

  const getAudioDuration = (url: string): Promise<number> => {
  return new Promise((resolve) => {
    const audio = new Audio(url);
    audio.addEventListener("loadedmetadata", () => {
      resolve(audio.duration || 0);
    });
  });
};


  useEffect(() => {
    fetchOverviewData();
  }, []);

  const fetchOverviewData = async () => {
    try {
      const res = await cognizantoverviewgetmetho();
 
      if (res?.status === "Success") {
        setGameDialogs(res.data);
      }
    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };


      const matchedDialogs = useMemo(() => {
      if (!currentGameId || !gameDialogs[currentGameId]) return [];

      return gameDialogs[currentGameId].filter(
        (d: any) => Number(d.questNumber) === hubDialogQuestNo
      );
    }, [currentGameId, gameDialogs, hubDialogQuestNo]);



useEffect(() => {
  if (!audioUrl) {
    
    console.warn("❌ Audio URL empty, not sending to parent");
    return;
  }
  if (isQuestTransitionActive) return; 

  
  // ## FULL AUDIO OBJECT CREATE PANNU
  const audioData = {
    url: audioUrl,
    type: EnumType.VOICE,  // ## Ethu voice audio nu specify pannu
    autoplay: true,        // ## Automatic play aganum
    Voicevolume: 1.0,      // ## Voice volume full
    BGMvolume: 0.0         // ## BGM volume zero
  };
  
  setHubDialogAudio(audioData);

}, [audioUrl, dialogIndex,isQuestTransitionActive]);


const [isDialogCompleted, setIsDialogCompleted] = useState(false);


useEffect(() => {
    if (isQuestTransitionActive) return;
  const dialog = currentDialogs[dialogIndex];
  if (!dialog || !audioUrl) return;

  // ## API CHARACTER VALUE
  const speakerName = (dialog.characters || "").trim().toLowerCase();

  let whospeak: "PC" | "NPC" | "" = "";
  let characteraction = "";

  // ## PARSE EMOTION
  let emotion = "";
  try {
    const parsed = JSON.parse(dialog.emotions || "[]");
    emotion = parsed[0]?.toUpperCase() || "";
  } catch {
    emotion = "";
  }

  // 🧠 FINAL DECISION — MATCH API RESPONSE
  if (speakerName === "narrator") {
    // 🎙️ NARRATOR → ALL IDLE
    whospeak = "";
    characteraction = "";
  } 
  else if (speakerName === "player") {
    // 🧍 PLAYER → PC ANIMATION
    whospeak = "PC";
    characteraction = emotion;
  } 
  else {
    // 👤 ANY OTHER NAME → NPC
    whospeak = "NPC";
    characteraction = emotion;
  }

  const audio = new Audio(audioUrl);

  const trigger = () => {
    const duration = audio.duration || 0;



    SetGlbPlayingDetails({
      whospeak,
      characteraction,
      audioduration: duration,
    });
  };

  // ## AUDIO METADATA SAFE CHECK
  if (audio.readyState >= 1) {
    trigger();
  } else {
    audio.addEventListener("loadedmetadata", trigger, { once: true });
  }

  return () => {
    audio.removeEventListener("loadedmetadata", trigger);
  };
}, [dialogIndex, audioUrl,isQuestTransitionActive]);



// 🔥 ZOOM DETECTION (TOP OF COMPONENT)
const getZoomLevel = () => {
  return Math.round((window.outerWidth / window.innerWidth) * 100);
};

const [zoomLevel, setZoomLevel] = React.useState(getZoomLevel());

React.useEffect(() => {
  const handleResize = () => {
    setZoomLevel(getZoomLevel());
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

const isZoomed = zoomLevel >= 140;


//new by kaviyaa for certifucate 

useEffect(() => {
  const progress = getGameProgress();

  if (progress?.firstTimeCompleted) {
    setCertificateUnlocked(true);
  }
}, []);


const progress = getGameProgress();

const finalQuestNo = Object.keys(progress?.quests || {}).length;

const totalQuests = learnerPlayList?.questState?.length || 4;


const isFinalQuestDialog =
  !progress?.firstTimeCompleted &&
  Number(hubDialogQuestNo) === totalQuests + 1;


const allQuestsReplayAllowed = (() => {
  if (!learnerPlayList?.questState) return false;
  return Object.values(learnerPlayList.questState).every(
    (state) => state === "replayallowed"
  );
})();


//const showCertificateButton =
 // progress?.firstTimeCompleted || allQuestsReplayAllowed;
   const showCertificateButton = overallqueststate;

// const showCertificateButton =
//   progress?.firstTimeCompleted || isFinalQuestDialog;



const handleNavigation = (direction: "left" | "right") => {

 if (isAudioPaused) {
    toggleAudioPlayPause();
  }
  if (direction === "right") {

    // 🛑 LAST DIALOG
    if (dialogIndex === currentDialogs.length - 1) {
     
        const progress = getGameProgress();
const isReplay = progress?.firstTimeCompleted === true;

      // ## STOP AUDIO
      setHubDialogAudio({
        url: "",
        type: EnumType.VOICE,
        autoplay: false,
        Voicevolume: 0,
        BGMvolume: 0,
      });

      // ## RESET ANIMATION
      SetGlbPlayingDetails({
        audioduration: 0,
        characteraction: "",
        whospeak: "",
      });

       // ✅certifictae
  if (isFinalQuestDialog) {
     markGameFirstTimeCompleted();
    //jascode
        markDialogShown(String(hubDialogQuestNo));
  setCurrentScreenId(16);
  return;
}

  if (isReplay) {
    setIsDialogCompleted(true);
    return;
  }
      setIsDialogCompleted(true);
      return;
    }

    // ▶️ NEXT DIALOG
    setDialogIndex(prev => prev + 1);
  }

  if (direction === "left" && dialogIndex > 0) {
    setDialogIndex(prev => prev - 1);
  }
}
  const formattedText = displayText.replace(/\t/g, " ");

const hasDialogStartedRef = useRef(false);

useEffect(() => {
      // Only play when dialog JUST completed — not on activeDoor changes
      if (!hasDialogStartedRef.current) return;
      if (!isDialogCompleted) return;
      if (completedQuestVideo) return;
      if (!activeDoor) return;

      // Small delay so it feels like a "reveal" after dialog ends
      const timer = setTimeout(() => {
        try {
          if (audioCtxRef.current) {
            audioCtxRef.current.close();
            audioCtxRef.current = null;
          }
          audioCtxRef.current = new AudioContext();
          playHubHologram(audioCtxRef.current);
        } catch (e) { }
      }, 400); // 400ms after dialog completes

      return () => {
        clearTimeout(timer);
        if (audioCtxRef.current) {
          audioCtxRef.current.close();
          audioCtxRef.current = null;
        }
      };
    }, [isDialogCompleted]);
const handleSkipDialog = () => {


  // 🔇 Stop audio
  setHubDialogAudio({
    url: "",
    type: EnumType.VOICE,
    autoplay: false,
    Voicevolume: 0,
    BGMvolume: 0,
  });

  // 🧍 Stop animation
  SetGlbPlayingDetails({
    audioduration: 0,
    characteraction: "",
    whospeak: "",
  });

  // 🧠 Mark dialog completed
  setIsDialogCompleted(true);
};

useEffect(() => {
  if (isLastMilestoneQuest && isDialogCompleted) {
    setCurrentScreenId(16);
  }
}, [isDialogCompleted, isLastMilestoneQuest]);

const [activePulseQuest, setActivePulseQuest] = useState<number | null>(1);


const completedLevels = (profile?.completedLevels || []).map(String);


useEffect(() => {
  if (!profile?.completedLevels) return;

  const completedLevels = profile.completedLevels.map(String);

  if (!completedLevels.includes('1')) {
    setActivePulseQuest(1);
  } else if (!completedLevels.includes('2')) {
    setActivePulseQuest(2);
  } else if (!completedLevels.includes('3')) {
    setActivePulseQuest(3);
  } else if (!completedLevels.includes('4')) {
    setActivePulseQuest(4);
  } else {
    setActivePulseQuest(null); // all completed
  }
}, [profile?.completedLevels]);


// ## ADD THIS ##
const [clickedDoors, setClickedDoors] = useState<Record<number, boolean>>({});




const startedQuestNo = useMemo(() => {
  if (!questState) return null;

  const entry = Object.entries(questState).find(
    ([, status]) => status === 'Started'
  );

  return entry ? entry[0] : null;
}, [questState]);



const isDoorActive = (questNo: number) => {
  const status = questState?.[questNo];

  // ## 1. Dialog complete aagala na → NO EFFECT ##
  if (!isDialogCompleted) {
    return false;
  }

  // ## 2. Door already click pannina → NO EFFECT ##
  if (clickedDoors?.[questNo]) {
    return false;
  }

  // ## 3. Quest Started na mattum dhaan effect ##
  return status === 'Started';
};

// const hologramAudioRef = useRef<HTMLAudioElement | null>(null);
    const audioCtxRef = useRef<AudioContext | null>(null);
const activeDoor = [1,2,3,4].find((door) => isDoorActive(door));
    function playHubHologram(ctx: AudioContext) {
      const now = ctx.currentTime;
      const freqs = [440, 554, 659, 880];
      freqs.forEach((freq, i) => {
        const t = now + i * 0.12;
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = 'sine';
        osc.frequency.setValueAtTime(freq, t);
        gain.gain.setValueAtTime(0, t);
        gain.gain.linearRampToValueAtTime(0.35, t + 0.02);
        gain.gain.setValueAtTime(0.35, t + 0.15);
        gain.gain.exponentialRampToValueAtTime(0.001, t + 0.5);
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.start(t);
        osc.stop(t + 0.52);
      });
      const sparkle = ctx.createOscillator();
      const sparkleGain = ctx.createGain();
      sparkle.type = 'sine';
      sparkle.frequency.setValueAtTime(1760, now + 0.5);
      sparkleGain.gain.setValueAtTime(0, now + 0.5);
      sparkleGain.gain.linearRampToValueAtTime(0.3, now + 0.52);
      sparkleGain.gain.exponentialRampToValueAtTime(0.001, now + 1.0);
      sparkle.connect(sparkleGain);
      sparkleGain.connect(ctx.destination);
      sparkle.start(now + 0.5);
      sparkle.stop(now + 1.02);
    }



const getQuestStatus = (questNo:any) => {
  if (!questState || !questState[questNo]) return 'locked';
  return questState[questNo];
};

const isQuestCompleted = (questNo:any) => {
  const status = getQuestStatus(questNo);
  const currentPoints = questWisePlayerScore?.[questNo] || 0;
  const totalPoints = gameInfo?.gameQuest?.find((q:any) => q.gameQuestNo === questNo)?.gameTotalScore || 0;
  const filledStars = Math.floor(currentPoints / (totalPoints / 3));
  
  // Either questState is 'replayallowed' OR all 3 stars are filled
  return status === 'replayallowed';
};


const getDisplayStatus = (questNo:any) => {
  const status = getQuestStatus(questNo);
  const isCompleted = isQuestCompleted(questNo);
  
  if (isCompleted) {
    return 'Mission Completed';
  }
  
  if (status === 'Started') {
    return 'Authorized';
  }
  
  if (status === 'locked') {
    return 'Access Restricted';
  }
  
  if (status === 'replayallowed') {
    return 'Mission Completed';
  }
  
  return 'Access Restricted';
};

const [showHubToast, setShowHubToast] = useState(false);
 const [isTransitioning, setIsTransitioning] = useState(false);


useEffect(() => {
  if (!currentGameId) return;
  if (isQuestTransitionActive) return;

  const progress = getGameProgress();
  if (!progress) return;

  const isFirstTime = !progress.firstTimeCompleted;

  if (isFirstTime) {
    // 🟢 FIRST TIME → Each quest shows its own dialog once

    const shouldShow =
      !progress?.quests?.[String(hubDialogQuestNo)]?.dialogShown;

    if (matchedDialogs.length > 0 && shouldShow) {

      // 🔥 If this is QUEST 1 → store its dialogs permanently
      if (Number(hubDialogQuestNo) === 1 && !progress.questOneDialogs) {
        progress.questOneDialogs = matchedDialogs;
        saveGameProgress(progress);
      }

      setCurrentDialogs(matchedDialogs);
      setDialogIndex(0);
      setIsDialogCompleted(false);
// pri
      markDialogShown(String(hubDialogQuestNo));
// pri
      hasDialogStartedRef.current = true; 

    } else {
      // setIsDialogCompleted(true);
        //  hasDialogStartedRef.current = false;
          setCurrentDialogs([]);
      setIsDialogCompleted(true);
      hasDialogStartedRef.current = false;
    }

 
 
  }
  

 else {
    // ❌ Quest 2–5 → NO dialog
    setCurrentDialogs([]);
    setIsDialogCompleted(true);
      hasDialogStartedRef.current = false;
  }
}, [
  matchedDialogs,
  currentGameId,
  isQuestTransitionActive,
  
  hubDialogQuestNo
]);

useEffect(() => {
  // ## Dialog complete aagalana → no toast ##
  if (!isDialogCompleted) return;

  // ## Quest start aagalana → no toast ##
  if (!startedQuestNo) return;

  // ## SHOW TOAST ##
  setShowHubToast(true);

  // ## AUTO HIDE AFTER 3 SECONDS ##
  const timer = setTimeout(() => {
    setShowHubToast(false);
  }, 27000);

  return () => clearTimeout(timer);
}, [isDialogCompleted, startedQuestNo]);
const [isDoorTransition, setIsDoorTransition] = useState(false);
const doorToastPositionMap: Record<string, any> = {
    "1": { top: "35%", left: "12%" },
    "2": { top: "35%", left: "39%" },
    "3": { top: "35%", left: "63%" },
    "4": { top: "30%", left: "86%" },
  };



const [doorBlobUrl, setDoorBlobUrl] = useState<string>(() => {
    if (playingDoorVideo) {
      const videoSrc = doorVideoMap[playingDoorVideo];
      if (videoSrc && window._videoBlobCache?.has(videoSrc)) {
        return window._videoBlobCache.get(videoSrc)!;
      }
    }
    return '';
  });



  // 🔥 Fetch & cache door video (if not already cached)
  useEffect(() => {
    if (!playingDoorVideo) return;

    const videoSrc = doorVideoMap[playingDoorVideo];
    if (!videoSrc) return;

    // Already have it from lazy init? skip re-fetch
    if (window._videoBlobCache && window._videoBlobCache.has(videoSrc)) {
      setDoorBlobUrl(window._videoBlobCache.get(videoSrc)!);
      return;
    }

    // Fallback: fetch and cache
    fetch(videoSrc)
      .then((res) => res.blob())
      .then((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        if (!window._videoBlobCache) {
          window._videoBlobCache = new Map();
        }
        window._videoBlobCache.set(videoSrc, blobUrl);
        setDoorBlobUrl(blobUrl);
      })
      .catch(() => {
        setDoorBlobUrl(videoSrc);
      });
  }, [playingDoorVideo]);

  /////////////////////////////////////////////////doorrrrr video end ...........................


  // const [completionBlobUrl, setCompletionBlobUrl] = useState<string>(() => {
  //   if (completedQuestVideo) {
  //     const videoSrc = questCompletionVideoMap[completedQuestVideo];
  //     if (videoSrc && window._videoBlobCache?.has(videoSrc)) {
  //       return window._videoBlobCache.get(videoSrc)!;
  //     }
  //   }
  //   return '';
  // });

 
  // useEffect(() => {
  //   if (!completedQuestVideo) return;

  //   const videoSrc = questCompletionVideoMap[completedQuestVideo];
  //   if (!videoSrc) return;

  //   // Already have it from lazy init? skip re-fetch
  //   if (window._videoBlobCache && window._videoBlobCache.has(videoSrc)) {
  //     setCompletionBlobUrl(window._videoBlobCache.get(videoSrc)!);
  //     return;
  //   }

  //   // Fallback: fetch and cache
  //   fetch(videoSrc)
  //     .then((res) => res.blob())
  //     .then((blob) => {
  //       const blobUrl = URL.createObjectURL(blob);
  //       if (!window._videoBlobCache) {
  //         window._videoBlobCache = new Map();
  //       }
  //       window._videoBlobCache.set(videoSrc, blobUrl);
  //       setCompletionBlobUrl(blobUrl);
  //     })
  //     .catch(() => {
  //       setCompletionBlobUrl(videoSrc);
  //     });
  // }, [completedQuestVideo]);



// ##############################
// Completion Video Cache
// ##############################

const [completionBlobUrl, setCompletionBlobUrl] = useState("");

const completionInitRef = useRef<string | null>(null);
const completionFetchingRef = useRef<Set<string>>(new Set());

useEffect(() => {
  if (!completedQuestVideo) {
    setCompletionBlobUrl("");
    completionInitRef.current = null;
    return;
  }

  // ##############################
  // Already initialized for this quest
  // ##############################

  if (completionInitRef.current === completedQuestVideo) {
    return;
  }

  completionInitRef.current = completedQuestVideo;

  const videoSrc = questCompletionVideoMap[completedQuestVideo];

  if (!videoSrc) return;

  // ##############################
  // Already Cached
  // ##############################

  if (
    window._videoBlobCache &&
    window._videoBlobCache.has(videoSrc)
  ) {
    setCompletionBlobUrl(
      window._videoBlobCache.get(videoSrc)!
    );
    return;
  }

  // ##############################
  // Prevent duplicate fetch
  // ##############################

  if (completionFetchingRef.current.has(videoSrc)) {
    return;
  }

  completionFetchingRef.current.add(videoSrc);

  fetch(videoSrc)
    .then((res) => res.blob())
    .then((blob) => {
      const blobUrl = URL.createObjectURL(blob);

      if (!window._videoBlobCache) {
        window._videoBlobCache = new Map();
      }

      window._videoBlobCache.set(videoSrc, blobUrl);

      setCompletionBlobUrl(blobUrl);

      completionFetchingRef.current.delete(videoSrc);
    })
    .catch(() => {
      setCompletionBlobUrl(videoSrc);

      completionFetchingRef.current.delete(videoSrc);
    });

}, [completedQuestVideo]);



 
if (playingDoorVideo) {
  const progress = getGameProgress();
  const questKey = String(playingDoorVideo);
  const alreadyPlayed = progress?.quests?.[questKey]?.doorPlayed;

  if (alreadyPlayed) {
     setIsDoorEntry?.(true);
    handleChapter(playingDoorVideo);
    return null;
  }

  // ✅ Every render layum cache ah direct ah check pannunga
  const rawSrc = doorVideoMap[playingDoorVideo];
  const cachedBlob = rawSrc && window._videoBlobCache?.get(rawSrc);
  const finalSrc = cachedBlob || doorBlobUrl || rawSrc;

  return (
    <video
      ref={doorVideoRef}
      src={finalSrc}
      autoPlay
      playsInline
      muted={false}
      preload="auto"
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        zIndex: 9999,
        background: 'black',
      }}
      onLoadStart={startDoorTimeout}
      onWaiting={startDoorTimeout}
      onStalled={startDoorTimeout}
      onSuspend={startDoorTimeout}
      onCanPlay={clearTimeoutHandler}
      onCanPlayThrough={clearTimeoutHandler}
      onPlaying={clearTimeoutHandler}
      onEnded={handleVideoComplete}
      onError={() => {
      
        handleVideoComplete();
      }}
    />
  );
}




if (completedQuestVideo) {

  const progress = getGameProgress();

  const questKey = String(completedQuestVideo);

  const alreadyPlayed =
    progress?.quests?.[questKey]?.completionVideoPlayed;

  if (alreadyPlayed) {
    setCompletedQuestVideo(null);
    setCurrentScreenId(13);
    return null;
  }

  // ##############################
  // Use Blob URL if available
  // ##############################

  const videoSrc =
    completionBlobUrl ||
    questCompletionVideoMap[completedQuestVideo];

  return (
    <video
      ref={completionVideoRef}
      src={videoSrc}
      autoPlay
      playsInline
      muted={false}
      preload="auto"
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        zIndex: 9999,
        background: "black",
      }}
      onLoadStart={startCompletionTimeout}
      onWaiting={startCompletionTimeout}
      onStalled={startCompletionTimeout}
      onSuspend={startCompletionTimeout}
      onCanPlay={clearCompletionTimeout}
      onCanPlayThrough={clearCompletionTimeout}
      onPlaying={clearCompletionTimeout}
      onEnded={handleCompletionVideoComplete}
      onError={() => {
      
        handleCompletionVideoComplete();
      }}
    />
  );
}
  /////////////////////////////////////////////////////////dhar  end completion end   


  return (
    <>
     {isTransitioning && (
          <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-black">
            <div
              className="hud-core hud-core-big"



            >
              <div className="hud-halo" />
              <div className="hud-ring hud-ring-outer" />
              <div className="hud-ring hud-ring-middle" />
              <div className="hud-ring hud-ring-inner" />
              <div className="hud-arc hud-arc-1" />
              <div className="hud-arc hud-arc-2" />
              <div className="hud-dot hud-dot-1" />
              <div className="hud-dot hud-dot-2" />
              <div className="hud-center" />
              <div className="hud-scan" />
            </div>
          </div>
        )}








{showUnlockOverlay && (
  <div className="unlock-overlay active" id="unlock-overlay">
    <div className="unlock-card">
      <div className="unlock-scanlines"></div>
      <div className="unlock-icon"
      style={{color:'white'}}
      >⬡</div>
      <p className="unlock-subtitle">
        Authorization confirmed <br />
      </p>
      <h2 className="unlock-title" id="unlock-title">
        Quest {unlockedQuest} Unlocked
      </h2>
    </div>
  </div>
)}



      <QuestHubLab
        preloadedAssets={preloadedAssets}
        setModalLoaded={setModalLoaded}
        modalLoaded={modalLoaded}
        currentScreenId={currentScreenId}
        SetGlbPlayingDetails={SetGlbPlayingDetails}
        GlbPlayindDetails={GlbPlayindDetails}
        setIsZoomComplete={setIsZoomComplete}
        isZoomComplete={isZoomComplete}
        glbName={glbName}
        NonPlayerNameLanguage={NonPlayerNameLanguage}
        NonPlayerNameLanguageId={NonPlayerNameLanguageId}
        PlayerNameLanguage={PlayerNameLanguage}
        // ADD WALKING PROPS
          isAnimationPaused={isAnimationPaused}
        walkToQuest={walkToQuest}
        onWalkComplete={handleWalkComplete}
        isWalking={isWalking}
        setIsWalking={setIsWalking}
           mentorNameLanguage={mentorNameLanguage}
      
      />
<div className="relative w-full h-screen overflow-hidden bg-no-repeat bg-center bg-cover">

  <div className="w-full h-full flex flex-col justify-end px-4 sm:px-6 lg:px-10">

    {/* DIALOGUE BOX */}
  
      {currentDialogs.length > 0 && !isDialogCompleted && (
        
              <div className="relative w-full mx-auto">
                {/* ✅ SKIP BUTTON — OUTSIDE DIALOG */}
                {/* new for dialoge skip button kaviya */}
                {hubDialogQuestNo === 1 && dialogIndex === 0 && (
                <button
                  onClick={handleSkipDialog}
                  className="absolute -top-10 right-4 z-[999999] rounded-full px-5 py-2 text-sm font-semibold text-white backdrop-blur-md"
                  style={{
                    background: `linear-gradient(
                    90deg,
                    rgba(${hexToRgb(primaryColor)}, 0.6) 7.25%,
                    rgba(${hexToRgb(primaryColor)}, 0.15) 84.803%
                  )`,
                    border: `1px solid ${primaryColor}`,
                    boxShadow: `0px 0px 15.9542px rgba(${hexToRgb(primaryColor)}, 0.3)`,
                    backdropFilter: "blur(6px)",
                  }}
                >
                  Skip
                </button>
                )}
      <div
  className="relative w-full mx-auto rounded-2xl px-6 backdrop-blur-3xl"
  style={{
                    zIndex: 3000,
    pointerEvents: "auto",
    background: `linear-gradient(21deg, rgba(0, 0, 0, 0.80) -10.76%, rgba(${primaryColor}, 0.2) 107.18%)`,
    boxShadow: `0px 0px 11px 0px inset ${primaryColor}`,
    paddingTop: "0rem",
    paddingBottom: "1rem",
  }}
>
        <div className="flex gap-12">

          {/* AVATAR SECTION */}
          <div className="relative flex flex-col items-center">

            {/* Dark Avatar Backplate */}
            <div
              className="rounded-full"
              style={{
                background: "linear-gradient(21deg, rgb(10,10,10), rgb(50,50,50))",
                zIndex: 1,
                position: "absolute",
                top: "1.5rem",
                left: "4.5rem",
                width: "8rem",
                height: "8rem",
              }}
            />

            {/* Avatar Circle */}
            <div
              className="p-3 rounded-full"
              style={{
                background: `rgba(${primaryColor},0.12)`,
                zIndex: 3,
                position: "absolute",
                top: "1.75rem",
                left: "4.75rem",
              }}
            >
              <div
                className="relative rounded-full overflow-hidden border"
                style={{ borderColor: primaryColor, width: "6rem", height: "6rem" }}
              >
                {/* <img
                  src={NPC}
                  alt={characterName}
                  className="w-full h-full object-cover rounded-full"
                /> */}

                {/* // kishore change the avathor icon and name */}
                <img
  // src={isPlayer ? playerAvatar : NPC}
      src={isPlayer ? playerAvatar : mentorAvatar}
  // alt={isPlayer ? playerName : characterName}
  alt={characterName}
  className="w-full h-full object-cover rounded-full"
/>
              </div>

              {/* Glow Rim */}
              <div
                className="absolute inset-0 rounded-full pointer-events-none"
                style={{
                  boxShadow: `
                    inset 0px 0px 12px rgba(${primaryColor},0.3),
                    0px 0px 22px rgba(${primaryColor},0.4)
                  `
                }}
              />
            </div>

            {/* CHARACTER NAME */}
            <h2
              className="text-3xl tracking-tight text-center"
              style={{
                color: primaryColor,
                textShadow: `0px 0px 12px rgba(${primaryColor},0.7)`,
                marginBottom: "-3rem",
                marginLeft: "6rem",
                marginTop: "10rem",
              }}
            >
              {/* {characterName} */}
              {isPlayer ? playerName : characterName}
            </h2>
          </div>

          {/* RIGHT — DIALOGUE TEXT */}
          <div className="flex-1 relative">

            {/* Glow Effects */}
            <div
              className="absolute w-80 h-80 -top-32 right-10 rounded-full blur-[200px] opacity-25 mix-blend-screen"
              style={{ background: primaryColor }}
            />
            <div
              className="absolute w-80 h-80 -top-40 left-10 rounded-full blur-[200px] opacity-15 mix-blend-screen"
              style={{ background: primaryColor }}
            />

            <p
              className="font-rubik text-[1.17rem] leading-8 text-white min-h-[6rem] overflow-y-auto cursor-pointer hover:opacity-90"
            
              style={{ marginTop: "1rem", maxHeight: "10rem",marginLeft:'2rem' }}
            >
              {formattedText}
            </p>

          </div>
        </div>

        {/* NAVIGATION — LEFT & RIGHT ARROWS */}
        <div className="flex justify-between items-center w-full">
          <NavigationArrow
            direction="left"
            onClick={() => handleNavigation("left")}
            // primaryColor={primaryColor}
          />

          <NavigationArrow
            direction="right"
            onClick={() => handleNavigation("right")}
            // primaryColor={primaryColor}
          />
        </div>

        {/* BORDER GLOW */}
        <div
          className="absolute inset-0 rounded-2xl pointer-events-none"
          style={{
            boxShadow: `
              inset 0px 0px 12px rgba(${primaryColor},0.3),
              0px 0px 22px rgba(${primaryColor},0.2)
            `
          }}
        />

                </div>
              </div>
            )}

  </div> 

</div> 




{!showUnlockOverlay && doorToast?.questId !== "1" && !isSettingOpen && (
  <Box
    position="fixed"

    /* ## POSITION */
    top="15%"
    left="7%"

    /* ## FIXED SIZE */
    w="180px"
    minH="110px"

    /* ✅ FINAL TRANSFORM FIX */
    style={{
      transform: `translate(0, 0) scale(${scale})`,
      transformOrigin: "top left"
    }}

    textAlign="center"
    zIndex={1002}

    className={`quest-box ${
      isQuestCompleted(1) ? "completed" : "authorized"
    }`}

    bg="rgba(10, 25, 30, 0.85)"
    p="6px 10px"
    border="1px solid #00f2ff"
    boxShadow="0 0 15px rgba(0, 242, 255, 0.25)"
    backdropFilter="blur(8px)"
    clipPath="polygon(0 0, 92% 0, 100% 20%, 100% 100%, 8% 100%, 0 80%)"

    opacity={isQuestCompleted(1) ? 1 : 0.85}

    display="flex"
    flexDirection="column"
    justifyContent="space-between"

    _before={{
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "2px",
      height: "100%",
      bg: "#00f2ff",
      boxShadow: "0 0 6px #00f2ff",
    }}
  >
    {/* Title */}
    <Box
      fontSize="10px"
      fontWeight="700"
      letterSpacing="2px"
      textTransform="uppercase"
      color="#00f2ff"
      textShadow="0 0 8px #00f2ff"
    >
      Vision Deck
    </Box>

    {/* Quest No */}
    <Box
      fontSize="9px"
      textTransform="uppercase"
      letterSpacing="1.5px"
      color="#ffffff"
      opacity="0.9"
    >
      Quest 1
    </Box>

    {/* Status */}
    <Box
      fontSize="11px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      gap="4px"
      color={isQuestCompleted(1) ? "#00f2ff" : "rgba(0, 242, 255, 0.7)"}
      textShadow={isQuestCompleted(1) ? "0 0 8px #00f2ff" : "none"}
    >
      <svg width="8px" height="8px" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
        {isQuestCompleted(1) ? (
          <polyline points="20 6 9 17 4 12" />
        ) : (
          <>
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v6l4 2" />
          </>
        )}
      </svg>

      <span>{getDisplayStatus(1)}</span>
    </Box>

    {/* Stars */}
    <QuestStars
      currentPoints={questWiseMaxScore?.[0]?.maxScore || 0}
      totalPoints={questTotalScore?.[0]?.gameTotalScore || 0}
      gradientIdPrefix="quest-1"
    />

    {/* Label */}
    <p
      style={{
        fontSize: "10px",
        fontWeight: "700",
        letterSpacing: "2px",
        textTransform: "uppercase",
        color: "#00f2ff",
        marginTop: "5px",
        textShadow: "0 0 8px #00f2ff"
      }}
    >
      GOAL SETTING
    </p>

    {/* Progress */}
    <Box mt="-3px" mb="6px" px="4px" display="flex" justifyContent="center">
      {/* <QuestProgressBar
        questNo={1}
        progress={questWiseMaxScore?.[0]?.maxScore || 0}
        maxProgress={questTotalScore?.[0]?.gameTotalScore || 0}
      /> */}
      <QuestProgressBar
  questNo={1}
  progress={
    learnerPlayList?.questwiseprogress?.[0]?.progress ??
    questWiseMaxScore?.[0]?.maxScore ??
    0
  }
  maxProgress={
    learnerPlayList?.questwiseprogress?.[0]
      ? 1
      : questTotalScore?.[0]?.gameTotalScore ?? 0
  }
/>
      {/* <QuestProgressBar
  questNo={1}
  progress={learnerPlayList?.questwiseprogress?.[0]?.progress || 0}
  maxProgress={1}
/> */}
    </Box>

    {/* Score */}
    <Box fontSize="10px" color="rgba(255,255,255,0.9)">
      {questWiseMaxScore?.[0]?.maxScore || 0} / {questTotalScore?.[0]?.gameTotalScore || 0}
    </Box>
  </Box>
)}
    


{!showUnlockOverlay && doorToast?.questId !== "2" && !isSettingOpen && (
  <Box
    position="fixed"

    /* ## POSITION */
    top="18%"
    left="34%"

    /* ## FIXED SIZE */
    w="180px"
    minH="110px"

    /* ✅ EXACT SAME STYLE AS QUEST 1 */
    style={{
      transform: `translate(0, 0) scale(${scale})`,
      transformOrigin: "top left"
    }}

    textAlign="center"
    zIndex={1002}

    className={`quest-box ${
      isQuestCompleted(2) ? "completed" : "authorized"
    }`}

    bg="rgba(10, 25, 30, 0.85)"
    p="6px 10px"
    border="1px solid #00f2ff"
    boxShadow="0 0 15px rgba(0, 242, 255, 0.25)"
    backdropFilter="blur(8px)"
    clipPath="polygon(0 0, 92% 0, 100% 20%, 100% 100%, 8% 100%, 0 80%)"

    opacity={isQuestCompleted(2) ? 1 : 0.85}

    display="flex"
    flexDirection="column"
    justifyContent="space-between"

    _before={{
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "2px",
      height: "100%",
      bg: "#00f2ff",
      boxShadow: "0 0 6px #00f2ff",
    }}
  >
    {/* Title */}
    <Box
      fontSize="10px"
      fontWeight="700"
      letterSpacing="2px"
      textTransform="uppercase"
      color="#00f2ff"
      textShadow="0 0 8px #00f2ff"
    >
      Ops Bay
    </Box>

    {/* Quest No */}
    <Box
      fontSize="9px"
      textTransform="uppercase"
      letterSpacing="1.5px"
      color="#ffffff"
      opacity="0.9"
    >
      Quest 2
    </Box>

    {/* Status */}
    <Box
      fontSize="11px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      gap="4px"
      color={isQuestCompleted(2) ? "#00f2ff" : "rgba(0, 242, 255, 0.7)"}
      textShadow={isQuestCompleted(2) ? "0 0 8px #00f2ff" : "none"}
    >
      <svg width="8px" height="8px" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
        {(() => {
          const status = getQuestStatus(2);
          const isCompleted = isQuestCompleted(2);

          if (isCompleted) {
            return <polyline points="20 6 9 17 4 12" />;
          } else if (status === "Started") {
            return (
              <>
                <circle cx="12" cy="12" r="10" />
                <path d="M12 6v6l4 2" />
              </>
            );
          } else {
            return (
              <>
                <rect x="3" y="11" width="18" height="11" rx="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </>
            );
          }
        })()}
      </svg>

      <span>{getDisplayStatus(2)}</span>
    </Box>

    {/* Stars */}
    <QuestStars
      currentPoints={questWiseMaxScore?.[1]?.maxScore || 0}
      totalPoints={questTotalScore?.[1]?.gameTotalScore || 0}
      gradientIdPrefix="quest-2"
    />

    {/* Label */}
    <p
      style={{
        fontSize: "10px",
        fontWeight: "700",
        letterSpacing: "2px",
        textTransform: "uppercase",
        color: "#00f2ff",
        marginTop: "5px",
        textShadow: "0 0 8px #00f2ff"
      }}
    >
      DELEGATION
    </p>

    {/* Progress */}
    <Box mt="-3px" mb="6px" px="4px" display="flex" justifyContent="center">
      {/* <QuestProgressBar
        questNo={2}
        progress={questWiseMaxScore?.[1]?.maxScore || 0}
        maxProgress={questTotalScore?.[1]?.gameTotalScore || 0}
      /> */}
      <QuestProgressBar
  questNo={2}
  progress={
    learnerPlayList?.questwiseprogress?.[1]?.progress ??
    questWiseMaxScore?.[1]?.maxScore ??
    0
  }
  maxProgress={
    learnerPlayList?.questwiseprogress?.[1]
      ? 1
      : questTotalScore?.[1]?.gameTotalScore ?? 0
  }
/>
      {/* <QuestProgressBar
  questNo={2}
  progress={learnerPlayList?.questwiseprogress?.[1]?.progress || 0}
  maxProgress={1}
/> */}
    </Box>

    {/* Score */}
    <Box fontSize="10px" color="rgba(255,255,255,0.9)">
      {questWiseMaxScore?.[1]?.maxScore || 0} / {questTotalScore?.[1]?.gameTotalScore || 0}
    </Box>
  </Box>
)}


{!showUnlockOverlay && doorToast?.questId !== "3" && !isSettingOpen && (
  <Box
    position="fixed"

    /* ✅ POSITION */
    top="17%"
    left="56%"

    /* ✅ SIZE */
    w="180px"
    minH="110px"

    /* ✅ SAME TRANSFORM AS QUEST 2 (STABLE) */
    style={{
      transform: `translate(0, 0) scale(${scale})`,
      transformOrigin: "top left"
    }}

    textAlign="center"
    zIndex={1002}

    className={`quest-box ${
      isQuestCompleted(3) ? "completed" : "authorized"
    }`}

    bg="rgba(10, 25, 30, 0.85)"
    p="6px 10px"
    border="1px solid #00f2ff"
    boxShadow="0 0 15px rgba(0, 242, 255, 0.25)"
    backdropFilter="blur(8px)"
    clipPath="polygon(0 0, 92% 0, 100% 20%, 100% 100%, 8% 100%, 0 80%)"

    opacity={isQuestCompleted(3) ? 1 : 0.85}

    display="flex"
    flexDirection="column"
    justifyContent="space-between"

    _before={{
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "2px",
      height: "100%",
      bg: "#00f2ff",
      boxShadow: "0 0 6px #00f2ff",
    }}
  >
    {/* Title */}
    <Box
      fontSize="10px"
      fontWeight="700"
      letterSpacing="2px"
      textTransform="uppercase"
      color="#00f2ff"
      textShadow="0 0 8px #00f2ff"
    >
      Cognition Chamber
    </Box>

    {/* Quest No */}
    <Box
      fontSize="9px"
      textTransform="uppercase"
      letterSpacing="1.5px"
      color="#ffffff"
      opacity="0.9"
    >
      Quest 3
    </Box>

    {/* Status */}
    <Box
      fontSize="11px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      gap="4px"
      color={isQuestCompleted(3) ? "#00f2ff" : "rgba(0, 242, 255, 0.7)"}
      textShadow={isQuestCompleted(3) ? "0 0 8px #00f2ff" : "none"}
    >
      <svg width="8px" height="8px" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
        {(() => {
          const status = getQuestStatus(3);
          const isCompleted = isQuestCompleted(3);

          if (isCompleted) {
            return <polyline points="20 6 9 17 4 12" />;
          } else if (status === "Started") {
            return (
              <>
                <circle cx="12" cy="12" r="10" />
                <path d="M12 6v6l4 2" />
              </>
            );
          } else {
            return (
              <>
                <rect x="3" y="11" width="18" height="11" rx="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </>
            );
          }
        })()}
      </svg>

      <span>{getDisplayStatus(3)}</span>
    </Box>

    {/* Stars */}
    <QuestStars
      currentPoints={questWiseMaxScore?.[2]?.maxScore || 0}
      totalPoints={questTotalScore?.[2]?.gameTotalScore || 0}
      gradientIdPrefix="quest-3"
    />

    {/* Label */}
    <p
      style={{
        fontSize: "10px",
        fontWeight: "700",
        letterSpacing: "2px",
        textTransform: "uppercase",
        color: "#00f2ff",
        marginTop: "5px",
        textShadow: "0 0 8px #00f2ff",
      }}
    >
      GIVING FEEDBACK
    </p>

    {/* Progress */}
    <Box mt="-3px" mb="6px" px="4px" display="flex" justifyContent="center">
      {/* <QuestProgressBar
        questNo={3}
        progress={questWiseMaxScore?.[2]?.maxScore || 0}
        maxProgress={questTotalScore?.[2]?.gameTotalScore || 0}
      /> */}
      <QuestProgressBar
  questNo={3}
  progress={
    learnerPlayList?.questwiseprogress?.[2]?.progress ??
    questWiseMaxScore?.[2]?.maxScore ??
    0
  }
  maxProgress={
    learnerPlayList?.questwiseprogress?.[2]
      ? 1
      : questTotalScore?.[2]?.gameTotalScore ?? 0
  }
/>
      {/* <QuestProgressBar
  questNo={3}
  progress={learnerPlayList?.questwiseprogress?.[2]?.progress || 0}
  maxProgress={1}
/> */}
    </Box>

    {/* Score */}
    <Box fontSize="10px" color="rgba(255,255,255,0.9)">
      {questWiseMaxScore?.[2]?.maxScore || 0} / {questTotalScore?.[2]?.gameTotalScore || 0}
    </Box>
  </Box>
)}




{!showUnlockOverlay && doorToast?.questId !== "4" && !isSettingOpen && (
  <Box
    position="fixed"   /* ✅ FIXED */

    /* ✅ POSITION */
    top="16%"
    left="80%"

    /* ✅ SIZE */
    w="180px"
    minH="110px"

    /* ✅ SAME STABLE TRANSFORM */
    style={{
      transform: `translate(0, 0) scale(${scale})`,
      transformOrigin: "top left"
    }}

    textAlign="center"
    zIndex={1002}

    className={`quest-box ${
      isQuestCompleted(4) ? "completed" : "authorized"
    }`}

    bg="rgba(10, 25, 30, 0.85)"
    p="6px 10px"
    border="1px solid #00f2ff"
    boxShadow="0 0 15px rgba(0, 242, 255, 0.25)"
    backdropFilter="blur(8px)"
    clipPath="polygon(0 0, 92% 0, 100% 20%, 100% 100%, 8% 100%, 0 80%)"

    opacity={isQuestCompleted(4) ? 1 : 0.85}

    display="flex"
    flexDirection="column"
    justifyContent="space-between"

    _before={{
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "2px",
      height: "100%",
      bg: "#00f2ff",
      boxShadow: "0 0 6px #00f2ff",
    }}
  >
    {/* Title */}
    <Box
      fontSize="10px"
      fontWeight="700"
      letterSpacing="2px"
      textTransform="uppercase"
      color="#00f2ff"
      textShadow="0 0 8px #00f2ff"
    >
      Quantum Atrium
    </Box>

    {/* Quest No */}
    <Box
      fontSize="9px"
      textTransform="uppercase"
      letterSpacing="1.5px"
      color="#ffffff"
      opacity="0.9"
    >
      Quest 4
    </Box>

    {/* Status */}
    <Box
      fontSize="11px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      gap="4px"
      color={isQuestCompleted(4) ? "#00f2ff" : "rgba(0, 242, 255, 0.7)"}
      textShadow={isQuestCompleted(4) ? "0 0 8px #00f2ff" : "none"}
    >
      <svg width="8px" height="8px" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
        {(() => {
          const status = getQuestStatus(4);
          const isCompleted = isQuestCompleted(4);

          if (isCompleted) {
            return <polyline points="20 6 9 17 4 12" />;
          } else if (status === "Started") {
            return (
              <>
                <circle cx="12" cy="12" r="10" />
                <path d="M12 6v6l4 2" />
              </>
            );
          } else {
            return (
              <>
                <rect x="3" y="11" width="18" height="11" rx="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </>
            );
          }
        })()}
      </svg>

      <span>{getDisplayStatus(4)}</span>
    </Box>

    {/* Stars */}
    <QuestStars
      currentPoints={questWiseMaxScore?.[3]?.maxScore || 0}
      totalPoints={questTotalScore?.[3]?.gameTotalScore || 0}
      gradientIdPrefix="quest-4"
    />

    {/* Label */}
    <p
      style={{
        fontSize: "10px",
        fontWeight: "700",
        letterSpacing: "2px",
        textTransform: "uppercase",
        color: "#00f2ff",
        marginTop: "5px",
        textShadow: "0 0 8px #00f2ff",
      }}
    >
      CONFLICT MANAGEMENT
    </p>

    {/* Progress */}
    <Box mt="-3px" mb="6px" px="4px" display="flex" justifyContent="center">
      {/* <QuestProgressBar
        questNo={4}
        progress={questWiseMaxScore?.[3]?.maxScore || 0}
        maxProgress={questTotalScore?.[3]?.gameTotalScore || 0}
      /> */}
      <QuestProgressBar
  questNo={4}
  progress={
    learnerPlayList?.questwiseprogress?.[3]?.progress ??
    questWiseMaxScore?.[3]?.maxScore ??
    0
  }
  maxProgress={
    learnerPlayList?.questwiseprogress?.[3]
      ? 1
      : questTotalScore?.[3]?.gameTotalScore ?? 0
  }
/>
      {/* <QuestProgressBar
  questNo={4}
  progress={learnerPlayList?.questwiseprogress?.[3]?.progress || 0}
  maxProgress={1}
/> */}
    </Box>

    {/* Score */}
    <Box fontSize="10px" color="rgba(255,255,255,0.9)">
      {questWiseMaxScore?.[3]?.maxScore || 0} / {questTotalScore?.[3]?.gameTotalScore || 0}
    </Box>
  </Box>
)}











<Box
  position="absolute"
  inset={0}
  width="100%"
  height="100%"
  overflow="hidden"
  zIndex={1001}
>
 <DoorParticles
    x={fxPos.x}
    y={fxPos.y}
    trigger={fx}
  />
  <svg
    className="overlay"
    viewBox="0 0 2048 1170"
    preserveAspectRatio="none"
    width="100%"
    height="100%"
    style={{
      position: 'absolute',
      inset: 0,
      display: 'block'
    }}
  >
  <defs>
    <clipPath id="clipDoor1"><path d="M130,330 L390,360 L390,720 L130,740 Z" /></clipPath>
    <clipPath id="clipDoor2"><path d="M660,385 L910,405 L910,695 L660,715 Z" /></clipPath>
    <clipPath id="clipDoor3"><path d="M1158,405 L1408,385 L1408,715 L1158,695 Z" /></clipPath>
    <clipPath id="clipDoor4"><path d="M1658,360 L1918,330 L1918,740 L1658,720 Z" /></clipPath>

    <linearGradient id="scanGrad" x1="0" x2="0" y2="1">
      <stop offset="0%" stopColor="#00f2ff" stopOpacity="0" />
      <stop offset="50%" stopColor="#00f2ff" stopOpacity="0.4" />
      <stop offset="100%" stopColor="#00f2ff" stopOpacity="0" />
    </linearGradient>
  </defs>
     

  <path
  id="door1-hit"
  d="M130,330 L390,360 L390,720 L130,740 Z"
  className="holo-hit"
 onMouseEnter={() => {
  if (!isDoorActive(1) || isSettingOpen) return;
  playHoverBlip();
}}


  //new onclick by kaviya
onClick={(e) => {

  const active = isDoorActive(1) && !isSettingOpen;

  // play effects only if active
  if (active) {
    playClickWhoosh();
                setCurrentQuestNo(1);
  const rect = e.currentTarget
    .ownerSVGElement!
    .getBoundingClientRect();

  setFxPos({
    x: e.clientX - rect.left,
    y: e.clientY - rect.top,
  });

    setFx((p) => !p);
  }

  setClickedDoors((prev) => ({
    ...prev,
    1: true,
  }));

  handleQuestClickWithValidation("1");
}}
/>



{isDoorActive(1) &&  !isSettingOpen && (
   <>
  <g className="holo-group" id="door1-visuals">
    <path d="M130,330 L390,360 L390,720 L130,740 Z" className="holo-stroke" />
    <path
      className="scanline"
      d="M130,330 L390,390 L390,490 L130,430 Z"
      fill="url(#scanGrad)"
      clipPath="url(#clipDoor1)"
    />
  </g>
  
<g style={{ pointerEvents: "none" }}>
  {/* text */}
  <text
    x="260"
    y="540 "
    textAnchor="middle"
    // fill="white"
    fontSize="14"
    fontWeight="50"
    letterSpacing="1"
    style={{
       fill: "#ffffff", 
      fontFamily: "Orbitron, sans-serif",
      filter: "drop-shadow(0 0 6px cyan)"
    }}
  >
    CLICK HERE
  </text>

  {/* pulse animation */}
  <animate
    attributeName="opacity"
    values="1;0.5;1"
    dur="1.4s"
    repeatCount="indefinite"
  />

</g>

  </>
  
)}
 
<path
  id="door2-hit"
  d="M660,385 L910,405 L910,695 L660,715 Z"
  className="holo-hit"
  style={{ pointerEvents: 'all' }}
  onMouseEnter={() => {
  if (!isDoorActive(2) || isSettingOpen) return;
  playHoverBlip();
}}
  
    //new onclick by kaviya
  onClick={(e) => {

  const active = isDoorActive(2) && !isSettingOpen;

  // play effects only if active
  if (active) {
    playClickWhoosh();
                setCurrentQuestNo(2);

  const rect = e.currentTarget
    .ownerSVGElement!
    .getBoundingClientRect();

  setFxPos({
    x: e.clientX - rect.left,
    y: e.clientY - rect.top,
  });

    setFx((p) => !p);
  }

  // mark door clicked
  setClickedDoors((prev) => ({
    ...prev,
    2: true,
  }));

    // ## EXISTING LOGIC ##
    handleQuestClickWithValidation('2');
  }}
/>

     


{doorToast?.questId === '2' && (
          <DoorToast message={doorToast.message} />
        )}

{isDoorActive(2) && !isSettingOpen && (
  <>
<g className="holo-group" id="door2-visuals"
style={{ pointerEvents: 'none' }}>
  <path
    d="M660,385 L910,405 L910,695 L660,715 Z"
    className="holo-stroke"
  />
  <path
    className="scanline"
    d="M660,385 L910,405 L910,695 L660,715 Z"
    fill="url(#scanGrad)"
    clipPath="url(#clipDoor2)"
  />
</g>
<g style={{ pointerEvents: "none" }}>
  {/* text */}
  <text
    x="790"
    y="531"
    textAnchor="middle"
    // fill="white"
    fontSize="14"
    fontWeight="50"
    letterSpacing="1"
    style={{
       fill: "#ffffff", 
      fontFamily: "Orbitron, sans-serif",
      filter: "drop-shadow(0 0 6px cyan)"
    }}
  >
    CLICK HERE
  </text>

  {/* pulse animation */}
  <animate
    attributeName="opacity"
    values="1;0.5;1"
    dur="1.4s"
    repeatCount="indefinite"
  />

</g>
</>
)}





{/* DOOR 3 HIT AREA */}
<path
  id="door3-hit"
  d="M1158,405 L1408,385 L1408,715 L1158,695 Z"
  className="holo-hit"
   onMouseEnter={() => {
  if (!isDoorActive(3) || isSettingOpen) return;
  playHoverBlip();
}}
  
    //new onclick by kaviya
  onClick={(e) => {

  const active = isDoorActive(3) && !isSettingOpen;

  // play effects only if active
  if (active) {
    playClickWhoosh();
                setCurrentQuestNo(3);

  const rect = e.currentTarget
    .ownerSVGElement!
    .getBoundingClientRect();

  setFxPos({
    x: e.clientX - rect.left,
    y: e.clientY - rect.top,
  });

    setFx((p) => !p);
  }

  // mark door clicked
  setClickedDoors((prev) => ({
    ...prev,
    3: true,
  }));

    handleQuestClickWithValidation('3');
  }}
/>

{/* DOOR 3 TOAST */}
{doorToast?.questId === '3' && (
  <DoorToast message={doorToast.message} />
)}

{/* DOOR 3 ACTIVE VISUAL */}
{isDoorActive(3) &&   !isSettingOpen && (
  <>
  <g className="holo-group" id="door3-visuals" style={{ pointerEvents: 'none' }}>
    <path
      d="M1158,405 L1408,385 L1408,715 L1158,695 Z"
      className="holo-stroke"
    />
    <path
      className="scanline"
      d="M1158,405 L1408,385 L1408,715 L1158,695 Z"
      fill="url(#scanGrad)"
      clipPath="url(#clipDoor3)"
    />
  </g>
  <g style={{ pointerEvents: "none" }}>
  {/* text */}
  <text
    x="1280"
    y="540"
    textAnchor="middle"
    // fill="white"
    fontSize="14"
    fontWeight="50"
    letterSpacing="1"
    style={{
       fill: "#ffffff", 
      fontFamily: "Orbitron, sans-serif",
      filter: "drop-shadow(0 0 6px cyan)"
    }}
  >
    CLICK HERE
  </text>

  {/* pulse animation */}
  <animate
    attributeName="opacity"
    values="1;0.5;1"
    dur="1.4s"
    repeatCount="indefinite"
  />

</g>
</>
)}




     


{/* DOOR 4 HIT AREA */}
<path
  id="door4-hit"
  d="M1658,360 L1918,330 L1918,740 L1658,720 Z"
  className="holo-hit"
onMouseEnter={() => {
  if (!isDoorActive(4) || isSettingOpen) return;
  playHoverBlip();
}}
 
  //new onclick by kaviya
  onClick={(e) => {

  const active = isDoorActive(4) && !isSettingOpen;

  // play effects only if active
  if (active) {
    playClickWhoosh();
                setCurrentQuestNo(4);
  const rect = e.currentTarget
    .ownerSVGElement!
    .getBoundingClientRect();

  setFxPos({
    x: e.clientX - rect.left,
    y: e.clientY - rect.top,
  });

    setFx((p) => !p);
  }

  // mark door clicked
  setClickedDoors((prev) => ({
    ...prev,
    4: true,
  }));

    handleQuestClickWithValidation('4');
  }}
/>

{/* DOOR 4 TOAST */}
{doorToast?.questId === '4' && (
  <DoorToast message={doorToast.message} />
)}

{/* DOOR 4 ACTIVE VISUAL */}
{isDoorActive(4) &&  !isSettingOpen && (
  <>
  <g className="holo-group" id="door4-visuals" style={{ pointerEvents: 'none' }}>
    <path
      d="M1658,360 L1918,330 L1918,740 L1658,720 Z"
      className="holo-stroke"
    />
    <path
      className="scanline"
      d="M1658,360 L1918,330 L1918,740 L1658,720 Z"
      fill="url(#scanGrad)"
      clipPath="url(#clipDoor4)"
    />
  </g>
  <g style={{ pointerEvents: "none" }}>
  {/* text */}
  <text
    x="1780"
    y="540"
    textAnchor="middle"
    // fill="white"
    fontSize="14"
    fontWeight="50"
    letterSpacing="1"
    style={{
       fill: "#ffffff", 
      fontFamily: "Orbitron, sans-serif",
      filter: "drop-shadow(0 0 6px cyan)"
    }}
  >
    CLICK HERE
  </text>

  {/* pulse animation */}
  <animate
    attributeName="opacity"
    values="1;0.5;1"
    dur="1.4s"
    repeatCount="indefinite"
  />

</g>

 
</>
)}



      </svg>
          {/* {showCertificateButton && (
            <div>
              <CertificateButton onClick={handleCertificateClick} isDialogOpen={currentDialogs.length > 0} />

            </div>
          )} */}
          {showCertificateButton && (
            hasAssessment ? (
              <NormalCertificateButton
                onClick={handleCertificateClick}
                // isDialogOpen={currentDialogs.length > 0}
              />
            ) : (
              <CertificateButton
                onClick={handleCertificateClick}
                isDialogOpen={currentDialogs.length > 0}
              />
            )
          )}
       {doorToast && (
        <Box
          position="absolute"
          {...doorToastPositionMap[doorToast.questId]}
          pointerEvents="none"
          zIndex={2000}
        >
          <DoorToast message={doorToast.message} />
        </Box>
      )}
      </Box>
     


<audio
  ref={walkingAudioRef}
  src={WalkAudio}
  loop
  preload="auto"
/>
{milestoneQuest && (
  <MilestoneOverlay
    questId={milestoneQuest}
    onContinue={handleMilestoneContinue}
  />
)}

    </>
    
  );
};

export default ChapterPage;